var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVarlk3New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1190.55 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33 {\n        font-family: ArialUnicodeMS, ArialUnicodeMS;\n      }\n\n      .cls-34 {\n        letter-spacing: 0em;\n      }\n\n      .cls-35, .cls-21 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2, .cls-36, .cls-37 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-38, .cls-39 {\n        letter-spacing: 0em;\n      }\n\n      .cls-40 {\n        letter-spacing: 0em;\n      }\n\n      .cls-3, .cls-41 {\n        letter-spacing: 0em;\n      }\n\n      .cls-42, .cls-43, .cls-9, .cls-12, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-30, .cls-51, .cls-32 {\n        fill: #1d1d1b;\n      }\n\n      .cls-42, .cls-9 {\n        font-size: 4.86px;\n      }\n\n      .cls-52 {\n        letter-spacing: 0em;\n      }\n\n      .cls-53 {\n        fill: #e5007e;\n      }\n\n      .cls-54 {\n        fill: #010101;\n      }\n\n      .cls-55 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-4, .cls-56, .cls-57 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-43 {\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-58 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-6, .cls-59 {\n        letter-spacing: -.11em;\n      }\n\n      .cls-60, .cls-18 {\n        letter-spacing: -.11em;\n      }\n\n      .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-57, .cls-68, .cls-36, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73 {\n        font-family: AdobeMyungjoStd-Medium-KSCpc-EUC-H, 'Adobe Myungjo Std';\n        font-weight: 500;\n      }\n\n      .cls-61, .cls-33 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-7, .cls-63, .cls-74, .cls-75 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-76 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-62, .cls-16 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-77, .cls-78 {\n        letter-spacing: 0em;\n      }\n\n      .cls-79 {\n        letter-spacing: .31em;\n      }\n\n      .cls-80, .cls-67 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-81 {\n        letter-spacing: .04em;\n      }\n\n      .cls-82 {\n        fill: #fff;\n      }\n\n      .cls-10, .cls-83 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-78, .cls-84, .cls-47, .cls-39, .cls-85 {\n        font-family: AdobeArabic-Regular, 'Adobe Arabic';\n      }\n\n      .cls-86 {\n        letter-spacing: 0em;\n      }\n\n      .cls-11 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-12, .cls-45 {\n        font-size: 6px;\n      }\n\n      .cls-87 {\n        fill: #1e1e1d;\n      }\n\n      .cls-88 {\n        fill: none;\n      }\n\n      .cls-64 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-44 {\n        font-family: ZaraH1Sans-Regular, 'Zara H1 Sans';\n        font-size: 7px;\n      }\n\n      .cls-89 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-90 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-91 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-14 {\n        letter-spacing: .02em;\n      }\n\n      .cls-15 {\n        letter-spacing: .02em;\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-65, .cls-19, .cls-93 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-94 {\n        letter-spacing: 0em;\n      }\n\n      .cls-94, .cls-95, .cls-96, .cls-97, .cls-75 {\n        font-family: KozGoPr6N-Regular-90ms-RKSJ-H, 'Kozuka Gothic Pr6N';\n      }\n\n      .cls-98 {\n        letter-spacing: 0em;\n      }\n\n      .cls-46 {\n        font-family: Arial-BoldMT, Arial;\n        font-size: 8px;\n        font-weight: 700;\n      }\n\n      .cls-66, .cls-28 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-99 {\n        letter-spacing: .31em;\n      }\n\n      .cls-47, .cls-51, .cls-32 {\n        font-size: 7.46px;\n      }\n\n      .cls-100 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-101 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-17, .cls-95, .cls-69 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-102 {\n        fill: #1e1e1c;\n      }\n\n      .cls-103 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-104 {\n        letter-spacing: 0em;\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-20 {\n        letter-spacing: .17em;\n      }\n\n      .cls-106 {\n        letter-spacing: 0em;\n      }\n\n      .cls-107, .cls-22 {\n        letter-spacing: -.11em;\n      }\n\n      .cls-108 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-68, .cls-24 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-48 {\n        font-family: ArialMT, Arial;\n        font-size: 3.08px;\n      }\n\n      .cls-23 {\n        letter-spacing: .17em;\n      }\n\n      .cls-109 {\n        letter-spacing: 0em;\n      }\n\n      .cls-25 {\n        letter-spacing: .01em;\n      }\n\n      .cls-110 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-111 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-112 {\n        letter-spacing: .31em;\n      }\n\n      .cls-26 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-113 {\n        letter-spacing: .04em;\n      }\n\n      .cls-27 {\n        letter-spacing: .02em;\n      }\n\n      .cls-114 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-50, .cls-30 {\n        font-size: 5.5px;\n      }\n\n      .cls-115 {\n        letter-spacing: 0em;\n      }\n\n      .cls-116 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-29 {\n        letter-spacing: 0em;\n      }\n\n      .cls-117 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-97, .cls-31 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-118 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-70 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-119, .cls-85 {\n        letter-spacing: 0em;\n      }\n\n      .cls-120 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-121 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-71 {\n        letter-spacing: 0em;\n      }\n\n      .cls-122 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-123 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-124 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-125 {\n        fill: #e1261d;\n      }\n\n      .cls-73 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-126 {\n        letter-spacing: -.08em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    width: 1190.55,
    height: 841.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    width: 1190.55,
    height: 841.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    width: 1190.55,
    height: 841.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    width: 1190.55,
    height: 841.89
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "758.69 536.7 758.69 536.45 432.95 536.45 432.95 267.66 758.44 267.66 758.44 536.7 758.69 536.7 758.69 536.45 758.69 536.7 758.94 536.7 758.94 267.16 432.45 267.16 432.45 536.95 758.94 536.95 758.94 536.7 758.69 536.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M611.04,285.27h-.25c0,1.51-.5,2.87-1.31,3.85-.8.98-1.89,1.57-3.09,1.57h-21.89c-1.2,0-2.29-.59-3.09-1.57-.8-.98-1.3-2.34-1.3-3.85s.5-2.87,1.3-3.85c.8-.98,1.89-1.57,3.09-1.57h21.89c1.2,0,2.29.59,3.09,1.57.8.98,1.31,2.34,1.31,3.85h.5c0-1.62-.54-3.09-1.42-4.17-.88-1.07-2.11-1.75-3.48-1.75h-21.89c-1.37,0-2.6.68-3.48,1.75-.88,1.07-1.42,2.55-1.42,4.17s.54,3.09,1.42,4.17c.88,1.07,2.11,1.75,3.48,1.75h21.89c1.37,0,2.6-.68,3.48-1.75.88-1.07,1.42-2.55,1.42-4.17h-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M450.31,417.65v-.25c-1.51,0-2.87-.5-3.85-1.3-.98-.8-1.57-1.89-1.57-3.09v-21.89c0-1.2.59-2.29,1.57-3.09.98-.8,2.34-1.3,3.85-1.3s2.87.5,3.85,1.3c.98.8,1.57,1.89,1.57,3.09v21.89c0,1.2-.59,2.29-1.57,3.09-.98.8-2.34,1.3-3.85,1.3v.5c1.62,0,3.09-.54,4.17-1.42,1.07-.88,1.75-2.11,1.75-3.48v-21.89c0-1.37-.68-2.6-1.75-3.48-1.07-.88-2.55-1.42-4.17-1.42s-3.09.54-4.17,1.42c-1.07.88-1.75,2.11-1.75,3.48v21.89c0,1.37.68,2.6,1.75,3.48,1.07.88,2.55,1.42,4.17,1.42v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M740.58,417.65v-.25c-1.51,0-2.87-.5-3.85-1.3-.98-.8-1.57-1.89-1.57-3.09v-21.89c0-1.2.59-2.29,1.57-3.09.98-.8,2.34-1.3,3.85-1.3s2.87.5,3.85,1.3c.98.8,1.57,1.89,1.57,3.09v21.89c0,1.2-.59,2.29-1.57,3.09-.98.8-2.34,1.3-3.85,1.3v.5c1.62,0,3.09-.54,4.17-1.42,1.07-.88,1.75-2.11,1.75-3.48v-21.89c0-1.37-.68-2.6-1.75-3.48-1.07-.88-2.55-1.42-4.17-1.42s-3.09.54-4.17,1.42c-1.07.88-1.75,2.11-1.75,3.48v21.89c0,1.37.68,2.6,1.75,3.48,1.07.88,2.55,1.42,4.17,1.42v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M611.04,518.84h-.25c0,1.51-.5,2.87-1.31,3.85-.8.98-1.89,1.57-3.09,1.57h-21.89c-1.2,0-2.29-.59-3.09-1.57-.8-.98-1.3-2.34-1.3-3.85s.5-2.87,1.3-3.85c.8-.98,1.89-1.57,3.09-1.57h21.89c1.2,0,2.29.59,3.09,1.57.8.98,1.31,2.34,1.31,3.85h.5c0-1.62-.54-3.09-1.42-4.17-.88-1.07-2.11-1.75-3.48-1.75h-21.89c-1.37,0-2.6.68-3.48,1.75-.88,1.07-1.42,2.55-1.42,4.17s.54,3.09,1.42,4.17c.88,1.07,2.11,1.75,3.48,1.75h21.89c1.37,0,2.6-.68,3.48-1.75.88-1.07,1.42-2.55,1.42-4.17h-.25Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-53",
    points: "444.64 401.81 432.45 401.81 432.45 402.31 444.64 402.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-53",
    points: "759.15 401.81 746.96 401.81 746.96 402.31 759.15 402.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "806.91 450.78 806.91 451.08 891.72 451.45 891.62 474.31 807.11 473.94 807.21 450.79 806.91 450.78 806.91 451.08 806.91 450.78 806.61 450.78 806.51 474.54 892.21 474.91 892.32 450.86 806.61 450.48 806.61 450.78 806.91 450.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "717.36 490.91 717.36 490.61 612.78 490.61 612.78 434.52 717.06 434.52 717.06 490.91 717.36 490.91 717.36 490.61 717.36 490.91 717.66 490.91 717.66 433.92 612.18 433.92 612.18 491.21 717.66 491.21 717.66 490.91 717.36 490.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M486.14,443.23h-.73l-.29-.76h-1.34l-.28.76h-.72l1.3-3.35h.72l1.34,3.35ZM484.9,441.9l-.47-1.24-.45,1.24h.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M486.98,443.23v-3.35h1.43c.36,0,.62.03.78.09.16.06.29.17.39.32.1.15.15.33.15.53,0,.25-.07.46-.22.62-.15.16-.37.27-.66.31.15.08.27.18.36.28.09.1.22.28.38.54l.41.65h-.81l-.48-.73c-.18-.26-.29-.42-.36-.49l-.21-.14c-.07-.02-.18-.04-.34-.04h-.14v1.4h-.68ZM487.65,441.3h.5c.32,0,.53-.01.61-.04l.19-.14c.05-.07.07-.15.07-.25,0-.11-.03-.2-.09-.27-.06-.07-.14-.11-.25-.13-.05,0-.22-.01-.49-.01h-.53v.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "491.58 443.23 491.58 440.45 490.59 440.45 490.59 439.88 493.25 439.88 493.25 440.45 492.26 440.45 492.26 443.23 491.58 443.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M494.28,440.8h.64v.64h-.64v-.64ZM494.28,442.59h.64v.64h-.64v-.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "483.06 445.61 483.06 446.08 579.9 446.08 579.9 478.03 483.53 478.03 483.53 445.61 483.06 445.61 483.06 446.08 483.06 445.61 482.59 445.61 482.59 478.97 580.84 478.97 580.84 445.14 482.59 445.14 482.59 445.61 483.06 445.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "626.23 473.39 626.23 473.52 702.89 473.52 702.89 450.59 626.11 450.59 626.11 473.52 626.23 473.52 626.23 473.39 626.36 473.39 626.36 450.84 702.64 450.84 702.64 473.27 626.23 473.27 626.23 473.39 626.36 473.39 626.23 473.39"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-32",
    transform: "translate(439 327.54) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100% algod\xF3n / coton / cotton / algod\xE3o / katoen / cotone / \u0392\u0391\u039C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-51",
    transform: "translate(649.97 327.54) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "\u0392\u0391\u039A\u0399 / "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-94",
    x: 20.15,
    y: 0
  }, "\u30B3\u30C3\u30C8\u30F3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 49.97,
    y: 0,
    xmlSpace: "preserve"
  }, " / baumwolle /")), /*#__PURE__*/React.createElement("text", {
    className: "cls-51",
    transform: "translate(439 335.34) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "bomuld / bomba\u017E / "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 61.64,
    y: 0
  }, "\u68C9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 69.1,
    y: 0,
    xmlSpace: "preserve"
  }, " / "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-71",
    x: 74.82,
    y: 0
  }, "\uBA74"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 82.27,
    y: 0,
    xmlSpace: "preserve"
  }, " / katun / ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-47",
    transform: "translate(554.21 335.34) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uFEE6\uFEC4\uFED7")), /*#__PURE__*/React.createElement("text", {
    className: "cls-32",
    transform: "translate(568.54 335.34) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " / algod\xF3n / cot\xF3 / kotoia / bavlna / pamuk")), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M468.31,382.05c-.62,0-.89-.35-1.08-.6-.19-.26-.34-.44-.84-.44-.56,0-.77.23-1.02.51-.21.24-.48.54-.96.54-.52,0-.85-.34-1.11-.61-.26-.27-.42-.43-.68-.43-.91,0-1.52.89-1.52.9l-.53-.36s.8-1.18,2.06-1.18c.54,0,.88.35,1.14.63.25.26.41.42.65.42.19,0,.29-.1.49-.32.27-.3.64-.72,1.49-.72s1.13.4,1.35.69c.17.22.26.35.57.35.33,0,.45-.15.64-.39.22-.28.52-.65,1.2-.65s1.68.95,1.86,1.14l-.46.45c-.38-.39-1.07-.94-1.4-.94-.37,0-.5.16-.7.41-.21.27-.5.63-1.14.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "462.39 387.98 470.29 387.98 471.73 379.48 472.64 379.48 471.04 388.89 470.13 388.89 462.54 388.89 461.63 388.89 460.03 379.48 460.94 379.48 462.39 387.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 461.69,
    y: 389.75,
    width: 9.3,
    height: 0.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M464.58,385.61h1.05v.66h.45v-.66h.32v-.38h-.32v-1.91h-.48l-1.02,1.88v.41ZM465.63,385.24h-.67l.66-1.22h0v1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M467.08,384.83c0-.86.08-1.17.41-1.17s.41.32.41,1.17-.09,1.17-.41,1.17-.41-.31-.41-1.17M466.61,384.83c0,1.15.32,1.51.88,1.51s.88-.36.88-1.51-.32-1.5-.88-1.5-.88.36-.88,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M489.82,389.82l-3.59-6.04,2.3-2.37-.58-.63-2.16,2.25-2.64-4.44-2.48,4.36-2.11-2.26-.64.65,2.27,2.44-3.45,6.05h2.51l-.93.97.59.51,1.44-1.48h5.47l1.61,1.73.64-.65-1.01-1.08h2.76ZM487.99,388.78h-1.89l-2.31-2.48,1.69-1.74,2.51,4.22ZM483.17,380.67l1.87,3.15-1.81,1.88-1.81-1.94,1.75-3.08ZM478.55,388.78l2.39-4.2,1.65,1.77-2.33,2.42h-1.71ZM481.37,388.78l1.78-1.83,1.7,1.83h-3.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M495.53,389.78h9.41v-9.41h-9.41v9.41ZM499.84,381.28c-1.69.15-3.06,1.39-3.4,3.02v-3.02h3.4ZM500.18,382.17c1.61,0,2.92,1.31,2.92,2.92s-1.31,2.92-2.92,2.92-2.92-1.31-2.92-2.92,1.31-2.92,2.92-2.92M496.44,385.88c.33,1.55,1.59,2.74,3.16,2.99h-3.16v-2.99ZM504.03,388.87h-3.26c1.84-.28,3.25-1.86,3.25-3.78s-1.53-3.64-3.48-3.81h3.5v7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M499.6,385.22c0-.36.29-.66.66-.66s.66.3.66.66-.3.66-.66.66-.66-.29-.66-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M522.27,380.55h-9.37v.91h8.67l.81,3.02h-8.44c-.88,0-1.64.34-1.92.88-.16.32-2.35,4.23-2.35,4.23h15.02l-2.43-9.05ZM512.84,385.77c.05-.1.38-.38,1.1-.38h8.68l.89,3.3h-12.29c.55-.98,1.5-2.68,1.61-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M515.35,387.06c0-.36.29-.66.66-.66s.66.3.66.66-.3.66-.66.66-.66-.29-.66-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M518.83,387.06c0-.36.3-.66.66-.66s.66.3.66.66-.29.66-.66.66-.66-.29-.66-.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M534.13,379.67c2.98,0,5.4,2.42,5.4,5.4s-2.42,5.4-5.4,5.4-5.41-2.42-5.41-5.4,2.42-5.4,5.41-5.4M534.13,380.58c-2.48,0-4.5,2.01-4.5,4.5s2.01,4.5,4.5,4.5,4.5-2.01,4.5-4.5-2.01-4.5-4.5-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M535.08,381.62h-2.9v6.91h1v-2.88h2.9v-4.03h-1ZM535.08,384.65h-1.9v-2.03h1.9v2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M464,416.31h-.98v-.48l1.01-1.52h.42v1.57h.31v.43h-.31v.6h-.45v-.6ZM464,414.97h0l-.6.91h.61v-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M465.15,414.97c.04-.17.11-.31.18-.42.08-.11.16-.18.27-.23.1-.05.21-.07.33-.07.12,0,.24.02.34.07.1.04.19.12.27.23.08.11.14.24.19.42.04.17.07.39.07.63s-.02.47-.07.64c-.04.18-.11.32-.18.42-.08.11-.17.18-.27.23-.1.05-.21.07-.34.07s-.23-.02-.33-.07c-.1-.05-.19-.12-.27-.23-.08-.1-.14-.24-.18-.42-.04-.18-.07-.39-.07-.64s.02-.46.07-.63M465.57,415.91c0,.09.02.19.04.29.02.1.06.18.11.24l.21.1c.09,0,.16-.03.22-.1.05-.07.09-.15.12-.24.02-.1.04-.19.04-.29,0-.09,0-.19,0-.31,0-.11,0-.2,0-.29,0-.09-.02-.18-.04-.28-.02-.1-.06-.18-.12-.24-.05-.07-.12-.1-.22-.1l-.21.1c-.05.06-.09.14-.11.24-.02.1-.04.19-.04.28,0,.09,0,.19,0,.29,0,.11,0,.21,0,.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M468.88,415.15c-.02-.13-.08-.24-.17-.33-.1-.09-.21-.13-.34-.13-.11,0-.21.02-.29.08l-.2.2c-.05.09-.09.18-.11.29-.03.11-.04.22-.04.35,0,.11.01.23.04.33.02.11.06.2.11.29l.2.2c.08.05.18.07.29.07.15,0,.28-.05.37-.16.09-.11.15-.25.17-.43h.5c-.01.16-.05.31-.1.45-.06.13-.13.25-.22.35-.09.1-.2.17-.32.22-.12.05-.26.08-.4.08-.18,0-.34-.04-.49-.11-.14-.07-.27-.17-.37-.3-.1-.12-.18-.27-.23-.44-.05-.17-.08-.35-.08-.54s.03-.38.08-.55c.05-.17.13-.32.23-.45.1-.12.22-.23.37-.3.15-.07.31-.11.49-.11.13,0,.25.02.37.06.12.04.22.1.31.19.09.08.17.18.23.3.06.12.1.25.11.41h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M466.12,419.09c0-.53-.4-.9-.89-.9s-.91.42-.91.9.36.9.92.9c.53,0,.89-.4.89-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M468.35,419.09c0-.53-.39-.9-.89-.9s-.91.42-.91.9.36.9.92.9.89-.4.89-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M461.74,413.1c1.57-.27,2.31-1.43,2.31-1.43,0,0,.75,1.29,2.29,1.29s2.33-1.29,2.33-1.29c0,0,.9,1.13,2.27,1.4.08-.43.26-1.36.26-1.36l.8.16-1.95,10.42h-7.51l-1.84-10.42.8-.16s.18.94.25,1.39M461.88,413.92l1.34,7.57h6.18s1.43-7.66,1.43-7.66c0,0-1.39-.16-2.08-1.04-.7.51-1.27.96-2.52.96s-2.21-.96-2.21-.96c0,0-.71.86-2.15,1.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 461.53,
    y: 422.7,
    width: 9.61,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 461.53,
    y: 424.2,
    width: 9.61,
    height: 1.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "486.02 418.1 490.85 415.92 490.36 414.83 485.47 417.05 483.23 412.7 481.04 417.02 476.21 414.83 475.72 415.92 480.5 418.08 479.7 419.66 475.72 421.46 476.21 422.54 478.84 421.35 477.36 424.27 489.21 424.27 487.69 421.33 490.36 422.54 490.85 421.46 486.81 419.63 486.02 418.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M504.96,423.21h-9.45v-9.45h9.45v9.45ZM504.23,414.49h-7.99v7.99h7.99v-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M500.95,418.48c0,.4-.32.72-.72.72s-.71-.32-.71-.72.32-.72.71-.72.72.32.72.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M503.21,418.48c0,1.64-1.33,2.97-2.98,2.97s-2.98-1.33-2.98-2.97,1.33-2.97,2.98-2.97,2.98,1.33,2.98,2.97M500.23,414.8c-2.03,0-3.68,1.65-3.68,3.68s1.65,3.68,3.68,3.68,3.68-1.65,3.68-3.68-1.65-3.68-3.68-3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M523.3,423.43h-12.24l.1-.48c.09-.43.9-4.22,2.22-5.17,1-.72,2.09-.7,2.14-.69h6.19l-.35-2.77h-7.23v-.79h7.92l1.24,9.9ZM512.04,422.64h10.36l-.59-4.75h-6.31s-.88-.01-1.66.54c-.79.57-1.49,2.91-1.8,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M517.87,420.24c0-.43.35-.78.78-.78s.78.35.78.78-.35.79-.78.79-.78-.35-.78-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M515.69,420.24c0-.43.35-.78.78-.78s.78.35.78.78-.35.79-.78.79-.78-.35-.78-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M538.92,418.48c0,2.65-2.14,4.79-4.79,4.79s-4.79-2.15-4.79-4.79,2.14-4.79,4.79-4.79,4.79,2.15,4.79,4.79M534.13,412.8c-3.14,0-5.68,2.54-5.68,5.68s2.54,5.68,5.68,5.68,5.68-2.54,5.68-5.68-2.55-5.68-5.68-5.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M536.36,417.53c0-.57-.15-.99-.46-1.26-.31-.27-.72-.41-1.24-.41h-2.26v5.26h1.09v-1.89h1.09c.57,0,1.01-.13,1.32-.39.31-.26.46-.7.46-1.32M535.27,417.54c0,.28-.07.48-.21.6-.14.13-.33.19-.58.19h-.99v-1.55h.99c.25,0,.45.06.58.18.14.11.21.31.21.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M471.7,408.33h-10.72v-13.9h10.72v13.9ZM461.47,407.84h9.74v-12.92h-9.74v12.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 461.26,
    y: 397.29,
    width: 10.27,
    height: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M469.46,396.86c-.39,0-.7-.31-.7-.7s.31-.7.7-.7.7.32.7.7-.32.7-.7.7M469.46,395.74c-.24,0-.43.19-.43.43s.19.43.43.43.42-.19.42-.43-.19-.43-.42-.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M466.2,402.34v.12h-.15v.31h-.14v-.31h-.49v-.11l.54-.77h.09v.76h.15ZM465.9,402.34v-.58l-.41.58h.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M466.33,402.2l.03-.26.1-.21.12-.11.13-.04c.09,0,.17.04.24.14.09.11.13.27.13.46,0,.14-.02.25-.06.35-.04.1-.09.16-.15.21l-.18.06c-.11,0-.2-.07-.28-.2-.06-.11-.09-.24-.09-.4M466.49,402.21c0,.21.03.36.08.46l.12.08.1-.04.07-.14c.02-.1.04-.24.04-.42,0-.13-.02-.24-.04-.33l-.08-.14-.09-.03-.1.05s-.07.12-.08.22c-.02.1-.02.2-.02.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M468.64,401.58l.2.03.08.06v.14s-.02.07-.02.07l-.04-.04-.14-.13-.19-.05-.2.12c-.05.08-.08.17-.08.29,0,.14.04.27.12.36.08.1.19.15.3.15.09,0,.19-.04.28-.12h.03s.02,0,.02,0l-.06.08c-.1.1-.23.14-.38.14-.14,0-.25-.05-.35-.15-.09-.1-.14-.22-.14-.37,0-.16.05-.3.16-.42.11-.12.24-.17.4-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M467.97,401.81c-.11,0-.2-.09-.2-.2s.09-.2.2-.2.2.09.2.2-.09.2-.2.2M467.97,401.57l-.05.05.05.05.05-.05-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M463.77,401.65l.04-.04v-.02s-.03-.03-.03-.03h.02s.1.04.1.04l-.03.05c.18.04.26.15.26.26,0,.13-.11.27-.32.27s-.33-.12-.33-.27c0-.12.1-.24.28-.27M463.58,401.92c0,.1.07.2.23.2s.23-.1.23-.2-.08-.21-.23-.21-.23.1-.23.21M464.44,402.4c-.1,0-.35.02-.55.02l-.11.03-.16-.08h.02s.02,0,.02,0c.06,0,.15.01.24.01.15,0,.33,0,.46-.02l.08-.02h.02s.08.03.08.03l-.02.05c0,.22,0,.31-.02.41l-.05.07-.02-.06v-.45ZM464.45,401.57l-.14-.1-.04-.03.06-.02.17.04.05.04v.05s0,.29,0,.29h.09s.13-.05.13-.05l.1.05-.05.03h-.28v.24h.09c.05-.01.03-.04.14-.04l.1.04-.05.04h-.28s-.06.1-.06.1l-.03-.09v-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M490.52,406.47l-3.78-6.49,1.44-1.44-.26-.26-1.37,1.38-3-5.15-3.28,5.22-1.52-1.52-.26.26,1.58,1.59-4.03,6.4h3.72s-1.44,1.44-1.44,1.44l.26.26,1.7-1.7h6.22s1.78,1.8,1.78,1.8l.26-.26-1.53-1.53h3.51ZM489.73,406.02h-3.17s-2.92-2.92-2.92-2.92l2.78-2.78,3.32,5.7ZM483.54,395.39l2.68,4.61-2.84,2.85-2.78-2.78,2.94-4.67ZM476.87,405.99l3.54-5.62,2.72,2.72-2.91,2.91h-3.35ZM480.73,406l2.65-2.65,2.66,2.66h-5.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M478.34,404.1c.29-.19.45-.48.45-.5l-.08-.1-.03-.03h.03s.03,0,.03,0l.19.12s-.04.07-.1.17l.12.12c.09.06.08,0,.19.16v.04s-.02.04-.02.04l-.03-.02-.29-.31c-.14.16-.27.26-.44.34h-.04s-.01,0-.01,0l.03-.03ZM478.83,404.38l-.12-.07-.03-.02.05-.02h.17s.04.04.04.04v.04s0,.22,0,.22l.08.05h.28c.12-.01.06-.05.2-.05l.12.05-.04.04h-.57c-.11,0-.16-.03-.17-.11v-.18ZM479.36,403.45s-.04-.04-.14-.09l-.04-.02.06-.02.22.08v.04s0,.5,0,.5h.07c.07-.02.04-.05.16-.05l.09.05-.04.04h-.27c0,.29-.01.36-.03.4l-.05.06-.02-.07v-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M480.58,404.23l-.09-.06-.04-.02.06-.02h.13s.04.05.04.05v.05s0,.27,0,.27h.36s.12-.04.12-.04l.17.06-.05.04h-.01c-.14,0-.38,0-.65,0-.1,0-.37.01-.44.02l-.07.02s-.06-.01-.16-.06l-.04-.03h.02s.03,0,.03,0c.07,0,.19.01.31.01.1,0,.2,0,.31,0v-.27ZM480.48,403.47l-.02-.02.06-.02.2.09v.03s-.11.19-.11.19l.24.12c.11.04.07-.04.32.13l.05.07-.04.03-.06-.02c-.11-.06-.38-.18-.54-.29-.25.27-.57.38-.6.38h-.01s.04-.04.04-.04c.23-.1.5-.35.59-.54l-.11-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M485.62,404.31l-.09-.07-.03-.02.05-.02c.14.02.16.03.16.05v.04s0,.22,0,.22h.35s0-.24,0-.24l-.06-.07-.03-.02h.05s.16.05.16.05v.05s-.06.22-.06.22c.02,0,.03,0,.14,0l.14-.03.19.06-.07.04h-.01c-.11,0-.24-.01-.39-.01-.22,0-.46,0-.67.03l-.1.03-.2-.1h.02s.03,0,.03,0c.11.01.23.02.31.02h.12s-.01-.21-.01-.21ZM486.06,403.49c.11,0,.05-.05.22-.05l.1.05-.1.05c-.21,0-.52.01-.72.03l-.07.03-.17-.09h.02s.03,0,.03,0c.08.02.18.02.29.02.16,0,.33-.01.4-.02M486.05,403.74l-.06-.09-.02-.03h.05s.17.06.17.06l-.03.06c-.04.1-.1.24-.13.31h.11c.06-.02.02-.04.14-.04l.11.05-.07.04h-.15c-.2,0-.39,0-.59.02l-.07.02-.16-.09h.02s.03,0,.03,0c.06.01.15.02.24.02.1,0,.22,0,.34-.02.02-.04.06-.18.08-.31M485.74,403.94l-.05.08-.04-.06c-.01-.05-.04-.13-.12-.29v-.03s0-.01,0-.01l.03.02c.11.1.17.16.18.24v.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M487.06,404.08l-.05.08-.03-.06v-.43s-.11-.08-.11-.08l-.03-.02.05-.02c.16.01.18.02.18.05v.03s0,.12,0,.12h.29v-.15l-.09-.07-.03-.02.06-.02c.14.02.16.03.16.06v.04s0,.34,0,.34l-.02.17-.04.04-.03-.05h-.29ZM487.87,404.28c-.09,0-.35.01-.54.02l-.1.03-.16-.08h.02s.02,0,.02,0c.06,0,.14.01.24.01.15,0,.33,0,.46-.01l.09-.02h.02s.07.03.07.03v.05c-.01.22-.01.31-.04.41l-.05.07-.03-.06v-.44ZM487.06,403.79v.25h.29v-.25h-.29ZM487.61,403.51l-.11-.08-.04-.02.06-.02c.16.03.18.04.18.06v.04s0,.36,0,.36h.19v-.39l-.12-.1-.03-.02.05-.02c.18.04.21.06.21.08v.04s-.02.53-.02.53c0,.09-.03.15-.05.15l-.03-.08v-.16s-.2,0-.2,0v.11s-.07.13-.07.13l-.03-.08v-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M482.68,398.93c-.02.15-.13.26-.34.26-.21,0-.32-.14-.32-.28,0-.12.08-.24.26-.27h0s.05-.04.05-.04v-.02s-.03-.03-.03-.03h.02s.09.04.09.04l-.02.05c.19.03.27.13.28.24v.05ZM482.12,398.92c0,.11.08.21.23.21.17,0,.25-.1.25-.21s-.08-.21-.25-.21c-.15,0-.23.11-.23.21M483.06,399.37l.08.02-.03.05c-.02.11-.05.25-.06.31l.07.04-.05.02c-.11,0-.42.01-.52.01l-.05.1-.03-.06c0-.05-.01-.26-.03-.38l-.09-.06-.03-.02.05-.02.18.02h.42s.07-.03.07-.03h.02ZM482.89,399.77l.1-.02v-.33c-.07,0-.32.01-.44.02l-.02.03v.31s.36,0,.36,0ZM483.02,398.58l-.14-.11-.05-.02.05-.02.25.08v.05s-.01.43-.01.43c0,.16-.02.22-.04.25l-.03.02-.03-.1v-.09h-.15s-.05.03-.05.03l-.13-.07h.03s.07,0,.07,0h.24v-.24h-.15s-.06.03-.06.03l-.13-.07h.02s.03,0,.03,0h.09s.19,0,.19,0v-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M484.16,399.37l-.09-.06-.04-.02.06-.02h.13s.04.05.04.05v.04s0,.27,0,.27h.37s.12-.04.12-.04l.17.06-.05.04h-.01c-.14,0-.38,0-.64,0-.11,0-.37.01-.44.02l-.07.02s-.06-.01-.16-.06l-.04-.03h.02s.03,0,.03,0c.07.01.18.02.31.02.1,0,.2,0,.31,0v-.27ZM484.07,398.61l-.02-.03h.05s.2.07.2.07v.03s-.11.19-.11.19l.24.11c.11.05.07-.04.32.13l.05.07-.04.03-.06-.02c-.12-.06-.38-.18-.54-.29-.25.26-.57.38-.6.38h0s.04-.04.04-.04c.23-.1.5-.36.59-.55l-.11-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M529.5,406.01h9.26v-9.26h-9.26v9.26ZM538.31,399.94c-.45-1.29-1.48-2.31-2.77-2.74h2.77v2.74ZM538.1,401.39c0,2.18-1.78,3.96-3.96,3.96s-3.96-1.77-3.96-3.96,1.78-3.96,3.96-3.96,3.96,1.78,3.96,3.96M532.75,397.2c-1.31.44-2.35,1.48-2.79,2.79v-2.79h2.79ZM529.95,402.78c.43,1.3,1.45,2.32,2.74,2.77h-2.74v-2.77ZM535.59,405.55c1.27-.44,2.28-1.45,2.72-2.72v2.72h-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M500.93,402.83h-.14s-.12,0-.12,0h-.23s-.02,0-.02,0l.05-.07c.1-.12.19-.26.26-.39.07-.14.1-.25.1-.33l-.05-.13-.12-.05-.19.08h-.02s-.02.02-.02.02h-.01s.06-.1.06-.1l.23-.1.17.06.07.16c0,.06-.02.14-.07.23-.05.11-.11.21-.18.3l-.09.14-.02.02-.02.03s.06.03.19.03l.16-.02.08-.07.03-.02h.01s0,.03,0,.03l-.03.05-.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M506.14,405.88l-11.81-.18v-.23c.01-.05.36-5.52,9.99-5.26-.1-.4-.17-.67-.2-.75-.28-.77-3.95-1.72-6.2-2.14l.08-.45c1.01.19,6.09,1.2,6.54,2.43.15.42,1.46,6.06,1.52,6.3l.07.28ZM494.82,405.25l10.74.17c-.28-1.21-.79-3.39-1.13-4.75-8.16-.27-9.42,3.59-9.61,4.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "497.2 403.74 497.2 404.49 497.22 404.6 497.33 404.63 497.34 404.63 497.36 404.63 497.37 404.65 497.34 404.66 497.3 404.66 497.13 404.66 497.02 404.66 496.96 404.66 496.94 404.65 496.96 404.64 497.01 404.63 497.09 404.53 497.09 403.82 497.07 403.75 497.02 403.73 496.95 403.75 496.93 403.75 496.92 403.74 497 403.69 497.17 403.59 497.2 403.58 497.21 403.6 497.2 403.63 497.2 403.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M497.97,404.34v.37s0,.03,0,.03h-.04s-.03.02-.03.02h-.02s-.02-.01-.02-.01v-.42h-.11s-.24,0-.24,0h-.05s-.03-.03-.03-.03c0-.02.08-.15.24-.38.16-.23.26-.35.28-.35v.02s.01.03.01.03v.6h.03s.08-.02.08-.02l.02-.02h.01s.01.01.01.01v.05s-.03.05-.03.05v.02s-.07,0-.07,0h-.07ZM497.86,404.23v-.44l-.17.23-.1.16-.04.05h.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M498.59,403.59c.09,0,.17.05.24.15.06.1.09.23.09.38,0,.17-.03.3-.09.41-.06.1-.14.16-.24.16-.11,0-.19-.04-.26-.14-.06-.09-.09-.21-.09-.36,0-.09.01-.19.04-.28.03-.09.07-.17.12-.22l.19-.09ZM498.54,403.68l-.15.11c-.04.07-.06.16-.06.28,0,.16.03.29.08.4.06.1.13.16.21.16l.16-.11c.04-.08.06-.18.06-.31,0-.15-.03-.28-.09-.38-.06-.1-.13-.15-.22-.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "500.63 403.74 500.63 404.49 500.66 404.6 500.76 404.63 500.77 404.63 500.8 404.63 500.8 404.65 500.77 404.66 500.74 404.66 500.57 404.66 500.45 404.66 500.39 404.66 500.37 404.65 500.4 404.64 500.44 404.63 500.52 404.53 500.52 403.82 500.51 403.75 500.45 403.73 500.38 403.75 500.36 403.75 500.35 403.74 500.44 403.69 500.61 403.59 500.63 403.58 500.64 403.6 500.64 403.63 500.63 403.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M501.05,404.1l.23-.11.2.09.08.23c0,.1-.03.19-.09.26l-.21.11c-.1,0-.19-.04-.25-.12-.07-.08-.1-.18-.1-.31,0-.09.02-.19.07-.29.05-.09.11-.18.19-.25l.16-.1.15-.05.02.02-.02.02c-.12.04-.21.1-.28.18-.08.09-.12.2-.15.31M501.23,404.06l-.14.06-.05.16c0,.1.02.18.07.25l.17.11.14-.07.05-.17c0-.1-.02-.18-.07-.24l-.18-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M502.04,403.59c.1,0,.17.05.23.15.06.1.09.23.09.38,0,.17-.03.3-.09.41-.06.1-.14.16-.24.16-.11,0-.19-.04-.26-.14-.07-.09-.1-.21-.1-.36,0-.09.02-.19.04-.28.03-.09.07-.17.12-.22l.19-.09ZM501.99,403.68l-.15.11c-.04.07-.06.16-.06.28,0,.16.03.29.08.4.06.1.13.16.21.16l.16-.11c.04-.08.06-.18.06-.31,0-.15-.03-.28-.09-.38-.05-.1-.13-.15-.22-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M499.89,404.12h.02s-.1.12-.1.12l-.12.04-.1-.02-.18-.05-.07.02-.08.08h-.02c.06-.11.13-.16.22-.16l.15.03.12.03.16-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M503.39,403.49l.2.03.09.06v.04s0,.1,0,.1l-.03.07-.04-.04-.14-.13-.19-.05-.2.11c-.05.08-.08.18-.08.3,0,.14.04.26.12.36.08.1.18.15.3.15.1,0,.19-.04.28-.12h.03s.02,0,.02,0l-.06.09c-.1.09-.23.14-.38.14-.14,0-.25-.05-.34-.15-.09-.1-.14-.22-.14-.37,0-.17.05-.31.17-.42.11-.11.24-.17.4-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M502.73,403.73c-.11,0-.2-.08-.2-.2s.09-.19.2-.19.19.08.19.19-.09.2-.19.2M502.73,403.48l-.05.05h.1l-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M517.18,395.75c-3.1,0-5.63,2.52-5.63,5.63s2.52,5.63,5.63,5.63,5.63-2.52,5.63-5.63-2.52-5.63-5.63-5.63M517.18,396.21c2.72,0,4.96,2.12,5.15,4.79-.34-.17-1.02-.37-1.62.1-.65.51-1.52.47-2.39-.1-.88-.58-1.75-.37-2.23-.02-.43.32-1.16.58-2.22.08-.81-.39-1.48-.25-1.84-.12.22-2.65,2.45-4.73,5.15-4.73M517.18,406.55c-2.85,0-5.17-2.32-5.17-5.18v-.14c.27-.12.93-.32,1.75.07,1.24.59,2.1.19,2.5-.11.41-.3,1.17-.48,1.93.03.51.34,1.03.5,1.51.5.43,0,.84-.14,1.2-.42.58-.45,1.26-.12,1.47,0v.07c0,2.85-2.32,5.18-5.17,5.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M515.95,399.64l.13-.03.14.05-.05.03h0c-.12,0-.26,0-.39,0-.18,0-.36,0-.54.02l-.08.03-.18-.09h.01s.03,0,.03,0c.06.02.16.02.28.02.17,0,.38,0,.6-.01h.05ZM515.24,398.84l-.11-.07-.03-.02.05-.02.18.03h.39c.16-.01.07-.05.23-.05h.01l.07.04-.07.03c-.22,0-.48.01-.6.01l-.03.03v.32s0,.05.2.05h.26c.09,0,.06-.04.19-.04l.08.04-.05.04c-.07,0-.3,0-.47,0h-.18l-.11-.1v-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M517.29,398.69l-.14-.08-.03-.02.06-.02.16.04.04.03v.05s0,.51,0,.51h.07c.07-.01.04-.04.13-.04l.09.04-.05.04h-.24v.41c0,.09-.01.15-.04.21l-.03.02-.02-.07v-.47c-.21.1-.59.21-.69.21l-.07-.1v-.26s-.1-.06-.1-.06h-.02s.05-.03.05-.03l.17.02h.19s.07-.03.07-.03l.03-.27c-.1,0-.17.01-.26.02l-.06.02-.14-.07h.02s.02,0,.02,0h.15s.22,0,.22,0c.05,0,.02-.02.12-.02l.06.02-.04.05-.06.24.07.04-.04.02c-.12,0-.28.01-.34.02l-.03.03c0,.11,0,.16,0,.25l.03.03s.36-.03.64-.15v-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M518.45,399.16c-.02.13-.11.24-.3.24-.21,0-.33-.13-.33-.27,0-.12.09-.24.27-.26l.05-.04v-.03s-.02-.02-.02-.02h.02s.09.04.09.04l-.03.04c.17.04.25.13.26.26v.04ZM517.92,399.13c0,.11.08.21.23.21.15,0,.22-.1.22-.21s-.07-.21-.22-.21c-.16,0-.23.1-.23.21M518.76,398.7l-.12-.09-.03-.02.05-.02.17.05.02.03v.04s0,.83,0,.83c0,.26,0,.29-.03.35l-.03.02-.02-.06v-1.12Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(438.73 352.24) scale(1 1.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HECHO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 14.9,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 15.94,
    y: 0
  }, "EN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 21.53,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 22.57,
    y: 0
  }, "ESPA\xD1A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 39.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 40.14,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 41.8,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 42.85,
    y: 0
  }, "FABRICADO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 66.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 68.02,
    y: 0
  }, "EM"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-90",
    x: 74.32,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 75.37,
    y: 0
  }, "ESPANHA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 95.06,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 96.1,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 97.77,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 98.81,
    y: 0
  }, "MADE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 111.32,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 112.37,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 116.73,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 117.77,
    y: 0
  }, "SPAIN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 130.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 131.13,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 132.8,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 133.84,
    y: 0
  }, "FABRIQU\xC9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 154.48,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 155.52,
    y: 0
  }, "EN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 161.11,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-115",
    x: 162.16,
    y: 0
  }, "ESPAGNE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 181.23,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 182.28,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 183.94,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 184.99,
    y: 0
  }, "GEFABRICEERD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 215.72,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 216.77,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 221.13,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 222.17,
    y: 0
  }, "SPANJE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 237.51,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 238.56,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-109",
    x: 240.23,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 241.27,
    y: 0
  }, "FATTO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-86",
    x: 254.79,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-115",
    x: 255.83,
    y: 0
  }, "IN ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(438.73 359.44) scale(1 1.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SPAGNA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 17.27,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 18.06,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 19.73,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 20.53,
    y: 0
  }, "HERGESTELLT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-116",
    x: 48.44,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 49.24,
    y: 0
  }, "IN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 53.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 54.39,
    y: 0
  }, "SPANIEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 72.3,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 73.09,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 74.76,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 75.56,
    y: 0
  }, "KATA\u03A3KEYH"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 100.06,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 100.86,
    y: 0
  }, "I\u03A3\u03A0ANIA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 118.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 118.89,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 120.55,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 121.35,
    y: 0
  }, "\xDCRET\u0130M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 136.99,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 137.78,
    y: 0
  }, "YER\u0130"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 146.58,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 147.38,
    y: 0
  }, "\u0130SPANYA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 165.29,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 166.09,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 167.76,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 168.56,
    y: 0
  }, "FREMSTILLET"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 195.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 196,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 197.16,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-115",
    x: 197.96,
    y: 0
  }, "SPANIEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 215.86,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 216.66,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 218.33,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 219.12,
    y: 0
  }, "DIBUAT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 234.69,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 235.49,
    y: 0
  }, "DI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-120",
    x: 239.88,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 240.68,
    y: 0
  }, "SPANYOL ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(438.73 366.64) scale(1 1.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/ ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-42",
    transform: "translate(441.39 366.64) scale(1 1.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 0,
    y: 0
  }, "\uFE8E\uFEF4\uFEE7\uFE8E\uFE92\uFEB3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-78",
    x: 7.01,
    y: 0
  }, "\u0627"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 7.74,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-85",
    x: 8.77,
    y: 0
  }, "\uFEF2"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 11.18,
    y: 0
  }, "\uFED3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 12.51,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 13.54,
    y: 0
  }, "\uFECA\uFEE8\uFEBB")), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(469.33 366.64) scale(1 1.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 1,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 2.66,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-106",
    x: 3.66,
    y: 0
  }, "FEITO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 15.34,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 16.34,
    y: 0
  }, "EN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 21.93,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 22.92,
    y: 0
  }, "ESPA\xD1A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 39.44,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-119",
    x: 40.44,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-77",
    x: 42.11,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 43.1,
    y: 0
  }, "FET"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 50.28,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 51.27,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 54.25,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 55.24,
    y: 0
  }, "ESPANYA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 74.39,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 75.39,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 77.05,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 78.05,
    y: 0
  }, "ESPAINIAN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 100.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 101.09,
    y: 0
  }, "EGINA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 113.95,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 114.95,
    y: 0
  }, "/VYROBEN\xC9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 138.54,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-98",
    x: 139.53,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 142.24,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 143.24,
    y: 0
  }, "\u0160PANIELSKU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 168.42,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 169.41,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 171.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 172.07,
    y: 0
  }, "PROIZVEDENO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 201.75,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 202.75,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-104",
    x: 205.89,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-115",
    x: 206.89,
    y: 0
  }, "\u0160PANJOLSKA ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(439.5 297.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FUNDA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 18.42,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 21.56,
    y: 0
  }, "N\xD3RDICA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 45.46,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 48.6,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 50.66,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 53.8,
    y: 0
  }, "CAPA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 67.82,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70.96,
    y: 0
  }, "DE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 77.91,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 81.05,
    y: 0
  }, "EDRED\xC3O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 105.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 109.13,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 111.18,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 114.33,
    y: 0
  }, "DUVET"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 131.49,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 134.63,
    y: 0
  }, "COVER"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 151.77,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 154.92,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-79",
    x: 156.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 160.12,
    y: 0
  }, "HOUSSE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 180.92,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 184.06,
    y: 0
  }, "DE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 191.01,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 194.15,
    y: 0
  }, "COUETTE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-99",
    x: 217.51,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 220.66,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-99",
    x: 222.72,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 225.86,
    y: 0
  }, "DEKBEDHOES"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-112",
    x: 260.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 263.36,
    y: 0
  }, "/ ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-45",
    transform: "translate(439.5 304.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 0
  }, "COPRIPIUMINO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 38.32,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 39.68,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 41.74,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 43.1,
    y: 0
  }, "BETTBEZUG"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 72.54,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 73.91,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 75.96,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 77.33,
    y: 0
  }, "\u03A0\u0391\u03A0\u039B\u03A9\u039C\u0391\u03A4\u039F\u0398\u0397\u039A\u0397"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 127.31,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 128.68,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 130.74,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 132.1,
    y: 0
  }, "DYNEBETR\xC6K"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 166.64,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 168,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 170.06,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 171.42,
    y: 0
  }, "\u639B\u3051\u5E03\u56E3\u30AB\u30D0\u30FC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 213.42,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 214.78,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 216.84,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 218.2,
    y: 0
  }, "\uC774\uBD88"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 230.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-72",
    x: 231.56,
    y: 0
  }, "\uCEE4\uBC84"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 243.56,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 244.92,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 246.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 248.34,
    y: 0
  }, "P\xC5SLAKAN ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(439.5 311.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/ ")), /*#__PURE__*/React.createElement("text", {
    className: "cls-45",
    transform: "translate(442.83 311.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 0,
    y: 0
  }, "\u0641\uFE8E\uFEA4\uFEDF"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 8.72,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-84",
    x: 9.99,
    y: 0
  }, "\u0641\uFEFC\uFECF")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(470.22 311.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " / FUNDA N\xD3RDICA / FUNDA N\xD2RDICA / ZORRO NORDIKOA")), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(439.3 286.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CONT. 1 PIEZA | PIECE | PI\xC8CE")), /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "translate(545.67 384.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 0,
    y: 0
  }, "ZA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 5.7,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 8.3,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-110",
    x: 11.32,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 12.03,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 15.26,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 18.7,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 22.76,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-126",
    x: 25.12,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 25.84,
    y: 0
  }, "ESPA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 36.14,
    y: 0
  }, "\xD1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 39.4,
    y: 0
  }, "A,"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-103",
    x: 43.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 43.92,
    y: 0
  }, "S.A."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-100",
    x: 50.86,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 51.58,
    y: 0
  }, "AV."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-123",
    x: 58.1,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 58.82,
    y: 0
  }, "DI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 63.09,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 65.66,
    y: 0
  }, "UT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 71.25,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 74.26,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 77.09,
    y: 0
  }, "I\xD3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 81.49,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 84.75,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-110",
    x: 85.54,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 86.25,
    y: 0
  }, "ED."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-110",
    x: 92.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 93.42,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 94.38,
    y: 0
  }, "ND"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 100.94,
    y: 0
  }, "ITEX."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-123",
    x: 110.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 110.94,
    y: 0
  }, "ARTEIXO."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-123",
    x: 129.26,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 129.98,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-123",
    x: 133,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 133.72,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 136.55,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 139.99,
    y: 0
  }, "RU\xD1A"), /*#__PURE__*/React.createElement("tspan", {
    x: 152.07,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "translate(545.67 390.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 0,
    y: 0
  }, "C."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 3.49,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 4.39,
    y: 0
  }, ".F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 7.38,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 8.16,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-108",
    x: 8.74,
    y: 0
  }, "A-1534051"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 29.78,
    y: 0
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-59",
    x: 32.25,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 32.82,
    y: 0
  }, "(ZAR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-117",
    x: 42.08,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 45.04,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 48.21,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 51.58,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 55.59,
    y: 0
  }, "E."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 58.61,
    y: 0
  }, "COM/CONTACT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 89.92,
    y: 0
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 91.13,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 91.71,
    y: 0
  }, "IT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 94.92,
    y: 0
  }, "X"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 97.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 98.28,
    y: 0
  }, "US"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 103.72,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-60",
    x: 106.72,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 107.3,
    y: 0
  }, "LLC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 114.43,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 115.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-101",
    x: 115.79,
    y: 0
  }, "ZAR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 123.91,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 126.93,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 127.5,
    y: 0
  }, "HOM"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 138.05,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-107",
    x: 140.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 140.97,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 143.54,
    y: 0
  }, "RA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 149.04,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-89",
    x: 151.33,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 152.23,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 154.47,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-50",
    transform: "translate(545.67 396.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 0,
    y: 0
  }, "P."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 3.36,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 4.35,
    y: 0
  }, "L."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 7.38,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 8.37,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 10.6,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 12.98,
    y: 0
  }, "DA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 19.3,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 20.29,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 21.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 22.07,
    y: 0
  }, "CN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 28.16,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 30.74,
    y: 0
  }, "J"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 32.42,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 33.2,
    y: 0
  }, "13"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 38.13,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 38.92,
    y: 0
  }, "144.185/0001-50"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 72.14,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 73.12,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 77.19,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 80.63,
    y: 0
  }, "DA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 86.95,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 87.94,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 91.17,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 94.6,
    y: 0
  }, "ME"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 101.02,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 102.01,
    y: 0
  }, "S.A.S."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 112.1,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 113.09,
    y: 0
  }, "SIC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 119.25,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 120.24,
    y: 0
  }, "900.495"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 135.81,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 136.59,
    y: 0
  }, "729"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-75",
    x: 143.99,
    y: 0
  }, "\uFF08\u682A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-96",
    x: 154.27,
    y: 0
  }, "\uFF09")), /*#__PURE__*/React.createElement("text", {
    className: "cls-50",
    transform: "translate(545.67 402.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "ITX"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 5.75,
    y: 0
  }, "\u30B8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-97",
    x: 10.77,
    y: 0
  }, "\u30E3\u30D1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-95",
    x: 20.81,
    y: 0
  }, "\u30F3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 25.83,
    y: 0
  }, "(8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 29.24,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 31.71,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 32.29,
    y: 0
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 36.96,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 39.43,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 40.01,
    y: 0
  }, "27"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 44.68,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 47.15,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 47.72,
    y: 0
  }, "202"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 54.73,
    y: 0
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 55.94,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 56.52,
    y: 0
  }, "IT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 59.61,
    y: 0
  }, "X"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 62.39,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 62.97,
    y: 0
  }, "Canad"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 75.19,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 77.49,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 78.07,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 80.18,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 81.52,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 84.14,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 84.92,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 85.5,
    y: 0
  }, "\uC544\uC774"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-69",
    x: 95.53,
    y: 0
  }, "\uD2F0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 100.55,
    y: 0
  }, "\uC5D1\uC2A4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-69",
    x: 110.59,
    y: 0
  }, "\uCF54"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 115.61,
    y: 0
  }, "\uB9AC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 120.62,
    y: 0
  }, "\uC544"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 125.77,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 126.35,
    y: 0
  }, "\uC8FC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-69",
    x: 131.37,
    y: 0
  }, "\uC2DD\uD68C\uC0AC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 146.42,
    y: 0
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 147.21,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-61",
    x: 147.79,
    y: 0
  }, "\uC11C\uC6B8\uD2B9\uBCC4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 167.86,
    y: 0
  }, "\uC2DC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 173.01,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-50",
    transform: "translate(545.67 408.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-70",
    x: 0,
    y: 0
  }, "\uAC15"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-66",
    x: 5.33,
    y: 0
  }, "\uB0A8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-63",
    x: 10.65,
    y: 0
  }, "\uAD6C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 15.8,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 17.89,
    y: 0
  }, "\uC601\uB3D9\uB300"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 33.87,
    y: 0
  }, "\uB85C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 39.02,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 41.12,
    y: 0
  }, "51"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 46.41,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 48.87,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 50.97,
    y: 0
  }, "("), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-68",
    x: 52.35,
    y: 0
  }, "\uC0BC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-73",
    x: 57.68,
    y: 0
  }, "\uC131\uB3D9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 68.34,
    y: 0
  }, ")"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 69.55,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 71.64,
    y: 0
  }, "20"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-57",
    x: 76.93,
    y: 0
  }, "\uCE35"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 82.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 84.18,
    y: 0
  }, "2002"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-67",
    x: 94.76,
    y: 0
  }, "\uD638"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 99.9,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 102,
    y: 0
  }, "080-500-6445"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 131.48,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 132.26,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 134.36,
    y: 0
  }, "RU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 140.52,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 143.36,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 145.46,
    y: 0
  }, "80089402-2"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 170.78,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 171.56,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "translate(545.67 414.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 4.11,
    y: 0
  }, "A-"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 8.56,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 12.67,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 15.74,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 18.39,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 21.87,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 24.71,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 26.1,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 26.88,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-76",
    x: 28.27,
    y: 0
  }, "St"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 32.2,
    y: 0
  }, "\xE9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 34.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 35.99,
    y: 0
  }, "RT"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 41.07,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 45.37,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-114",
    x: 46.76,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 50.87,
    y: 0
  }, "ARO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 60.08,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 62.91,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 64.3,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 65.32,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 67.64,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 69.03,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 69.82,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 71.21,
    y: 0
  }, "1642262"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 88.8,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 89.58,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 90.97,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 91.75,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 93.15,
    y: 0
  }, "IMPOR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 107.03,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 109.46,
    y: 0
  }, "AD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 115.88,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 119.31,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-124",
    x: 120.71,
    y: 0
  }, "PO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 126.82,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 129.42,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 130.81,
    y: 0
  }, "ZAR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 139.26,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 142.28,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-91",
    x: 143.67,
    y: 0
  }, "HOM"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 154.55,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 156.9,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "translate(545.67 420.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 4.06,
    y: 0
  }, "EXI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 10.17,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 13,
    y: 0
  }, "O,"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 17.23,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 18.62,
    y: 0
  }, "S.A."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 25.56,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 26.95,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 30.26,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-81",
    x: 32.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 34.01,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 36.84,
    y: 0
  }, ".V.PO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 47.14,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 50.4,
    y: 0
  }, "IE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 53.72,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 56.98,
    y: 0
  }, "TE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 61.71,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 63.11,
    y: 0
  }, "146"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 70.5,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 71.89,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 75.15,
    y: 0
  }, "O."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 79.37,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 80.77,
    y: 0
  }, "730"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 88.16,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 89.55,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 92.38,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 95.82,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 98.06,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 101.49,
    y: 0
  }, "NI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 105.72,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 108.73,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 110.12,
    y: 0
  }, "IND"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 117.65,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 120.85,
    y: 0
  }, "ST"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 125.59,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 128.2,
    y: 0
  }, "IA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 132.17,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-113",
    x: 134.41,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-56",
    x: 135.8,
    y: 0
  }, "VALLEJO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 153.49,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "translate(545.67 426.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 3.01,
    y: 0
  }, "LCALD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 16.64,
    y: 0
  }, "IA AZ"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-83",
    x: 27.14,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-93",
    x: 29.97,
    y: 0
  }, "APOTZALCO, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 57.19,
    y: 0
  }, "C."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 60.81,
    y: 0
  }, "P. "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 64.98,
    y: 0
  }, "02300,"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 78.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 78.9,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 81.73,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 82.7,
    y: 0
  }, "UD"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 89.2,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 92.22,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 95.52,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-80",
    x: 96.34,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 99.64,
    y: 0
  }, "E "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 102.81,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 106.87,
    y: 0
  }, "EXI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 112.98,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 115.81,
    y: 0
  }, "O, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 120.85,
    y: 0
  }, "RFC:"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 129.4,
    y: 0
  }, "Z"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 132.08,
    y: 0
  }, "HM04"), /*#__PURE__*/React.createElement("tspan", {
    x: 144.31,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    className: "cls-30",
    transform: "translate(719.67 426.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 0,
    y: 0
  }, "609"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 7.39,
    y: 0
  }, "ES"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-74",
    x: 12.11,
    y: 0
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-52",
    x: 14.57,
    y: 0
  }, ".")), /*#__PURE__*/React.createElement("text", {
    className: "cls-46",
    transform: "translate(656.62 285.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "135x200 cm / 53x78.5 in.")), /*#__PURE__*/React.createElement("text", {
    className: "cls-44",
    transform: "translate(573.31 507.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "zarahom"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-121",
    x: 26.63,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.06,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-111",
    x: 31.6,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.68,
    y: 0
  }, "om")), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M662.67,513.11v16.98h-1.87v-7.51h-1.91v7.51h-1.89v-16.99h5.67ZM660.75,515.02h-1.85v5.63h1.85v-5.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "655.11 513.11 655.11 514.98 653.24 514.98 653.24 520.65 655.08 520.65 655.08 522.54 653.24 522.54 653.24 528.22 655.08 528.22 655.08 530.11 651.33 530.11 651.33 513.11 655.11 513.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "668.34 530.11 664.56 530.11 664.56 513.11 668.34 513.11 668.34 514.99 666.47 514.99 666.47 528.22 668.34 528.22 668.34 530.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M683.53,505.36c-3.34,0-4.52,5.29-5.62,9.53-.4-.41-1.62-1.65-1.62-1.65-.24-.25-.53-.17-.7,0-.17.18-.2.51,0,.7.01,0,1.66,1.68,2.22,2.26.16.15.39.25.61.11.24-.14.27-.41.28-.41,1.95-8.9,3.69-9.56,4.82-9.56.96,0,2.05.72,2.05,2.15,1.42,0,2.31,1.9,1.17,3.07.95.46,1.37,1.04,1.37,1.76s-.6,1.47-1.47,1.47c-.86,0-1.3-.57-1.98-.57-.31,0-.49.25-.49.5v1.79h-1.27v-1.79c0-.28-.2-.5-.46-.5h-.11s-1.71.22-1.71.22c-.21.03-.39.25-.39.49,0,.27.22.5.52.5h.08s1.08-.15,1.08-.15v1.77c0,.23.25.44.47.44h2.27c.26,0,.49-.23.49-.5v-1.62c.47.29,1.13.41,1.47.41,1.27,0,2.48-1.02,2.48-2.51,0-1.35-1.02-2.03-1.02-2.03.6-1.62-.37-3.18-1.62-3.61-.45-1.66-1.85-2.31-2.93-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M683.53,505.36c-3.34,0-4.52,5.29-5.62,9.53-.4-.41-1.62-1.65-1.62-1.65-.24-.25-.53-.17-.7,0-.17.18-.2.51,0,.7.01,0,1.66,1.68,2.22,2.26.16.15.39.25.61.11.24-.14.27-.41.28-.41,1.95-8.9,3.69-9.56,4.82-9.56.96,0,2.05.72,2.05,2.15,1.42,0,2.31,1.9,1.17,3.07.95.46,1.37,1.04,1.37,1.76s-.6,1.47-1.47,1.47c-.86,0-1.3-.57-1.98-.57-.31,0-.49.25-.49.5v1.79h-1.27v-1.79c0-.28-.2-.5-.46-.5h-.11s-1.71.22-1.71.22c-.21.03-.39.25-.39.49,0,.27.22.5.52.5h.08s1.08-.15,1.08-.15v1.77c0,.23.25.44.47.44h2.27c.26,0,.49-.23.49-.5v-1.62c.47.29,1.13.41,1.47.41,1.27,0,2.48-1.02,2.48-2.51,0-1.35-1.02-2.03-1.02-2.03.6-1.62-.37-3.18-1.62-3.61-.45-1.66-1.85-2.31-2.93-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M682.1,519.51c0,.42.46.67,1.21,1.03.6.29.94.59.94.83,0,.39-.41.53-.8.53-.6,0-.96-.24-1.15-.79l-.02-.05h-.05l-.24.06v.2s.12.56.12.56c.03.14.08.16.3.2.09.02.58.1.99.1,1.15,0,1.66-.48,1.66-.95,0-.34-.33-.67-1.05-1.04l-.33-.16c-.5-.24-.79-.38-.79-.63s.31-.41.75-.41c.57,0,.73.33.8.61v.05h.07c.13,0,.21-.01.25-.07l.03-.12-.04-.49c-.01-.15-.13-.18-.29-.21-.19-.04-.43-.08-.77-.08-1,0-1.59.3-1.59.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M685.41,520.49c0,.84.72,1.7,2.1,1.7.7,0,1.09-.16,1.38-.32l.08-.04-.13-.15h0s-.1-.04-.1-.04l-.07.02c-.1.05-.42.2-1.01.2-.71,0-1.48-.47-1.48-1.52s.83-1.34,1.54-1.34c.51,0,.78.19.83.57v.06h.07c.06,0,.22,0,.22-.12v-.58c0-.14-.16-.16-.23-.17h-.07c-.16-.03-.32-.05-.74-.05-1.4,0-2.42.75-2.42,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M680.21,518.76h-1.25s-.83,0-.83,0h-.12s-.13.13-.13.13c0,.04,0,.15.14.15.5,0,.52.04.52.24v.12s.01.52.01.52v1.12c0,.19,0,.48-.02.72,0,.07,0,.13-.45.13-.12,0-.2.02-.2.15l.12.13h.03c.05,0,.19,0,.88,0,.74,0,.89,0,.93,0h.03c.1,0,.18,0,.18-.13,0-.14-.11-.15-.3-.15-.44,0-.45-.06-.45-.13-.01-.22-.02-.51-.02-.72v-.4h.37c.57,0,.63.02.72.46l.16.11c.13,0,.15-.08.15-.11v-.17c-.02-.09-.03-.21-.03-.38v-.69l-.19-.1c-.11,0-.13.07-.2.39-.03.12-.26.2-.64.2h-.34v-1.01c0-.27.05-.27.11-.28.22-.01.75-.03.91-.03.15,0,.29.03.38.1.28.18.43.3.51.37l.2.11.16-.11-.05-.13c-.04-.1-.12-.27-.22-.54-.03-.08-.12-.08-.29-.08h-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M682.94,526.27h-.27v-1.81h0l-.63,1.81h-.26l-.62-1.84h0v1.84h-.27v-2.16h.43l.52,1.53c.06.17.09.28.1.32h0c.03-.08.07-.2.12-.35l.52-1.5h.38v2.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 683.57,
    y: 524.11,
    width: 0.29,
    height: 2.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M686.26,526.27h-.36l-.43-.61c-.11-.15-.17-.25-.2-.3h0s-.21.32-.65.92h-.34l.84-1.13-.74-1.04h.34l.46.65.11.18c.04-.07.24-.34.61-.82h.31l-.76,1.02.82,1.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "673.95 528.31 672.77 528.31 672.77 528.98 673.79 528.98 673.79 529.24 672.77 529.24 672.77 530.22 672.48 530.22 672.48 528.06 673.95 528.06 673.95 528.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M675.74,528.69c-.01-.14-.06-.24-.15-.31-.09-.07-.22-.11-.38-.11-.15,0-.27.03-.36.08l-.14.24.11.21c.07.04.21.09.41.14.18.04.33.08.44.12l.29.19c.08.09.12.2.12.35,0,.18-.08.34-.22.46-.15.12-.34.18-.58.18-.3,0-.53-.07-.68-.2-.15-.13-.23-.31-.24-.53l.28-.02c.01.17.08.3.2.38.12.08.27.12.44.12.16,0,.29-.03.39-.1l.15-.27-.16-.26c-.11-.06-.28-.11-.52-.16-.24-.05-.42-.13-.53-.22-.11-.1-.16-.22-.16-.37,0-.17.07-.32.21-.43.13-.12.32-.17.56-.17s.44.05.58.17c.15.11.23.27.24.48l-.28.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M678.43,529.53c-.06.25-.17.42-.33.54-.16.12-.35.18-.57.18-.35,0-.61-.11-.78-.33-.16-.22-.24-.49-.24-.8,0-.34.09-.61.28-.81.19-.19.44-.29.74-.29.21,0,.39.05.54.16.15.11.26.26.32.47l-.28.07c-.05-.15-.12-.26-.22-.34-.1-.08-.22-.11-.36-.11-.24,0-.41.08-.54.23-.12.15-.18.36-.18.62,0,.3.07.53.2.67.13.15.29.22.5.22.17,0,.31-.05.41-.14.11-.09.18-.23.22-.41l.29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M680.31,528.74h-.11v-.61h0l-.18.61h-.11l-.19-.62h0v.62h-.11v-.72h.18l.18.58h0l.17-.58h.18v.72ZM679.52,528.12h-.24v.62h-.12v-.62h-.23v-.1h.59v.1Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-48",
    transform: "translate(681.99 530.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0000000")), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M451.91,512.37c3.21,1.64,5.21,4.89,5.21,8.5s-1.87,6.64-4.88,8.32c-.17.1-.35.18-.35.18l-.58-1.13.3-.16c2.61-1.46,4.23-4.22,4.23-7.21s-1.73-5.95-4.52-7.37l.58-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M443.27,512.37l.57,1.13c-2.79,1.42-4.52,4.24-4.52,7.37s1.62,5.76,4.23,7.21l.29.16-.58,1.13-.33-.17c-3.01-1.69-4.88-4.88-4.88-8.33s2-6.86,5.22-8.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M450.45,514.61c2.44,1.12,4.02,3.58,4.02,6.26s-1.41,4.89-3.67,6.09c-.11.06-.23.12-.35.17l-.53-1.15.29-.14c1.85-.97,2.99-2.88,2.99-4.97s-1.29-4.19-3.28-5.1l.53-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M444.73,514.61l.53,1.16c-1.99.91-3.28,2.92-3.28,5.11s1.15,3.99,2.99,4.96l.28.14-.53,1.16c-.12-.06-.22-.11-.34-.17-2.27-1.2-3.68-3.53-3.68-6.09,0-2.69,1.58-5.14,4.02-6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M448.79,517.07c1.67.53,2.79,2.06,2.79,3.81,0,1.58-.94,3.02-2.39,3.66-.13.06-.27.11-.41.15l-.38-1.21.27-.1c.99-.43,1.63-1.41,1.63-2.49,0-1.19-.77-2.23-1.9-2.59l.38-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M446.39,517.06l.38,1.21c-1.14.36-1.9,1.4-1.9,2.59,0,1.08.64,2.06,1.63,2.49l.27.1-.39,1.21c-.13-.04-.27-.09-.39-.15-1.45-.64-2.39-2.07-2.39-3.65,0-1.75,1.12-3.28,2.79-3.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M446.62,520.87c0-.53.43-.97.97-.97s.97.43.97.97-.43.97-.97.97-.97-.43-.97-.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M468.37,524.01l1.49-1.43.02.73h1.29s1.28-.02,1.28-.02l.22-.08c.12-.04.29-.12.36-.17.46-.32.58-.92.29-1.54-.04-.09-.47-.84-.95-1.68-.48-.83-.87-1.52-.86-1.54l1.14-.65s.4.69.87,1.51c.97,1.67,1.05,1.83,1.18,2.21.5,1.48-.1,2.7-1.53,3.11-.44.12-.48.13-1.91.15h-1.37s-.03.85-.03.85l-1.5-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M463.41,524.56c-.94-.16-1.62-.61-1.93-1.27-.14-.28-.18-.48-.19-.85-.02-.39.02-.66.17-1.09.12-.36.26-.64.83-1.62.26-.45.47-.82.47-.82l-.62-.38,1.99-.56.49,1.99-.71-.32c-.08.11-1.01,1.74-1.07,1.88-.11.24-.15.48-.14.71.03.49.29.81.82.99l.21.07h1.9s1.9.02,1.9.02v1.31h-1.92c-1.71,0-1.95,0-2.19-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M464.09,516.67s1.62-2.89,1.84-3.21c.24-.35.61-.73.91-.93.18-.13.54-.29.77-.35.58-.15,1.25,0,1.79.4.27.2.66.62.86.93.1.15.4.65.67,1.12.27.47.5.86.5.87l.64-.34-.5,2-1.98-.56.66-.43s-1.02-1.79-1.14-1.97c-.32-.45-.79-.68-1.2-.6-.33.07-.65.29-.87.61-.06.08-.49.81-.95,1.61-.47.81-.86,1.47-.87,1.47-.38-.19-.77-.4-1.12-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M467.75,520.8v.62h-2.4v-.46l.85-.92c.58-.64.68-.8.68-1.1s-.21-.5-.6-.5c-.41,0-.7.16-.85.3h-.01v-.75c.17-.1.5-.23.96-.23.8,0,1.29.46,1.29,1.11,0,.51-.21.86-.85,1.5l-.43.43h1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M470.55,520.8v.62h-2.4v-.46l.85-.92c.58-.64.68-.8.68-1.1s-.21-.5-.6-.5c-.41,0-.7.16-.85.3h-.01v-.75c.17-.1.5-.23.96-.23.8,0,1.29.46,1.29,1.11,0,.51-.21.86-.85,1.5l-.43.43h1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M464.59,526.99c.18-.03.44-.06.78-.06.37,0,.65.08.83.23.17.14.27.36.27.62s-.08.48-.24.63c-.2.2-.52.3-.89.3-.1,0-.18,0-.25-.02v1.05h-.51v-2.76ZM465.09,528.29c.06.02.15.02.25.02.38,0,.62-.19.62-.51s-.22-.48-.57-.48c-.14,0-.24.01-.29.02v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M467.37,528.95l-.24.79h-.53l.9-2.79h.65l.91,2.79h-.55l-.25-.79h-.89ZM468.18,528.57l-.22-.69c-.05-.17-.1-.36-.14-.52h0c-.04.16-.08.36-.13.52l-.22.69h.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M469.65,526.99c.18-.03.44-.06.78-.06.37,0,.65.08.83.23.17.14.27.36.27.62s-.08.48-.24.63c-.2.2-.52.3-.89.3-.1,0-.18,0-.25-.02v1.05h-.51v-2.76ZM470.16,528.29c.06.02.15.02.25.02.38,0,.62-.19.62-.51s-.22-.48-.57-.48c-.14,0-.24.01-.29.02v.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M529.59,512.12h-30.36v11.37c0,3.87,3.19,7.01,7.12,7.01h30.36v-11.37c0-3.87-3.19-7.01-7.12-7.01M536,529.8h-29.65c-3.54,0-6.41-2.83-6.41-6.3v-10.68h29.65c3.54,0,6.41,2.83,6.41,6.3v10.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M503.73,509.3h-.24v.98h.25c.19,0,.3-.13.3-.5,0-.32-.1-.49-.31-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M504.89,508.03h-4.24c-.78,0-1.41.64-1.41,1.41v3.38h7.07v-3.38c0-.78-.64-1.41-1.42-1.41M502.49,509.3h-.96v.81h.76v.57h-.76v1.43h-.66v-3.38h1.62v.56h0ZM504.05,512.12l-.35-1.34h-.22v1.34h-.67v-3.38h.97c.57,0,.91.31.91,1,0,.49-.16.76-.39.89l.44,1.49h-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M529.59,512.12h-14.41l4.97,8.44-4.87,9.94h21.43v-11.37c0-3.87-3.19-7.01-7.12-7.01M531.97,527.89c0,.29-.24.53-.53.53h-.45c-.22,0-.41-.13-.49-.32-.16.2-.41.32-.69.32h-4.9c-.28,0-.53-.13-.69-.32-.08.19-.27.32-.49.32h-.45c-.29,0-.53-.24-.53-.53v-1.9c0-.29.24-.53.53-.53h.56c-.21-2.33-.53-5.95-.69-7.58-.02-.17.11-.32.27-.33.17-.02.32.11.33.27.24,2.51.88,9.69.89,9.77.01.12.13.22.27.22h4.9c.14,0,.26-.1.27-.22,0-.07.64-7.25.89-9.77.02-.17.16-.29.33-.27.17.02.29.16.27.33-.16,1.64-.48,5.25-.69,7.59h.11s.45-.01.45-.01c.29,0,.53.24.53.53v1.9ZM526.97,518.83c-.12-.12-.12-.31,0-.42.12-.12.31-.12.42,0l.94.94c.12.12.12.31,0,.42l-.94.94-.21.09-.21-.09c-.12-.12-.12-.31,0-.42l.43-.43h-.02c-1.14,0-2.07.93-2.07,2.07s.93,2.07,2.07,2.07,2.07-.93,2.07-2.07c0-.27-.05-.54-.16-.79-.06-.15,0-.33.16-.39.15-.06.33,0,.39.16.13.33.2.67.2,1.02,0,1.47-1.2,2.67-2.67,2.67s-2.67-1.2-2.67-2.67,1.2-2.67,2.67-2.67h.03l-.43-.43ZM532.36,516.54c0,.11-.03.22-.08.32l-.09.1c-.1.06-.21.1-.32.1h-8.96c-.11,0-.23-.03-.32-.1l-.1-.1c-.05-.1-.08-.21-.08-.32v-.8c0-.35.27-.63.6-.63h.52l.71-.62c.15-.13.38-.21.62-.21h5.04c.24,0,.47.08.62.21l.71.62h.52c.33,0,.6.28.6.63v.8h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M531.12,515.7l-.2-.07-.8-.7s-.12-.06-.23-.06h-5.04c-.11,0-.2.03-.23.06l-.8.7-.2.07h-.63v.04s-.01.73-.01.73h8.78v-.77h-.64ZM529.89,515.65h-5.04c-.14,0-.25-.11-.25-.25s.11-.25.25-.25h5.04c.14,0,.25.11.25.25s-.11.25-.25.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M489.91,521.13c-.76,1.12-.11,2.59.67,3.33.71.68,1.29.84,1.36.86l.36-.7,1.05,2.88-2.98.6.4-.73-.4-.23c-1.25-.82-1.52-1.92-1.6-2.27-.15-.6-.37-2.38,1.14-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M489.89,521.18c.54,1.24,2.13,1.48,3.18,1.21.93-.24,1.37-.62,1.45-.69l-.4-.7,2.99.65-1.08,2.84-.4-.71-.39.21c-1.36.62-2.44.26-2.78.14-.58-.19-2.21-.95-2.56-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M495.18,518.19c-.21,1.48-1.1,2.19-1.38,2.42-.48.39-2,1.35-3.87.56,1.34.21,2.39-.99,2.74-2.02.31-.92.22-1.5.2-1.59l-.79-.04,2.16-2.17,1.81,2.44-.82-.05-.03.45h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M486.1,516.94c-.68,0-1.24-.55-1.24-1.24s.55-1.24,1.24-1.24,1.24.55,1.24,1.24-.55,1.24-1.24,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M484.19,522.95c.11-.29.26-.27.26-.27,0,0,.14-.03.22.26l1.16,4.06c-.96-.28-1.84-.76-2.59-1.39l.95-2.66ZM487.8,512.12c-4.46,0-8.1,3.63-8.1,8.1s3.63,8.1,8.1,8.1c.24,0,.47-.01.71-.04l.05.81,1.48-1.43-1.66-1.26.06.85c-.21.02-.43.03-.65.03-.34,0-.68-.03-1.01-.07l-.03-.22-.77-6.56c-.11-1.24.6-1.43,1.04-1.25l2.45.99c.28.12.42-.11.42-.11,0,0,.16-.25-.12-.43,0,0-3.35-2.22-4.06-2.35-.97-.18-1.93.61-2.15,1.63l-1.19,5.82c-1.02-1.23-1.64-2.8-1.64-4.52,0-3.9,3.17-7.06,7.06-7.06,2.08,0,3.95.9,5.25,2.34l.73-.74c-1.48-1.62-3.61-2.64-5.97-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M513.55,516.87l-7.33-1.56c-.11-.03-.23,0-.32.08-.09.07-.14.19-.13.3v.07c.02.35,0,1.36-.05,1.89-.23,2.79-.99,5.22-2.19,7.03-.14.21-.35.5-.47.65l-.11.14c-.08.1-.1.24-.06.35.04.12.14.21.27.24l7.32,1.57h.08c.11,0,.22-.05.29-.14l.1-.12c.41-.51.86-1.3,1.22-2.11.8-1.81,1.33-3.99,1.56-6.49.03-.33.09-1.15.1-1.41v-.12c0-.18-.11-.34-.29-.38h.01ZM513.08,517.53c-.02.35-.07.92-.09,1.18-.23,2.42-.74,4.53-1.5,6.26-.32.72-.72,1.42-1.07,1.88l-6.52-1.4c.1-.13.19-.26.26-.37,1.27-1.91,2.07-4.46,2.31-7.37.03-.41.06-1.09.06-1.59l6.56,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M509.89,517.47c-.08-.09-.2-.14-.32-.14-.27,0-.5.26-.52.56-.01.16.04.32.14.43.08.09.2.14.32.14.27,0,.5-.26.52-.56,0-.17-.04-.32-.14-.43M509.57,517.49v.04l.17.07c.06.07.09.17.09.28,0,.2-.16.37-.33.37l-.17-.07c-.06-.07-.09-.17-.09-.28.01-.2.16-.37.32-.37v-.04h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "510.42 526.28 504.52 525 504.39 525.09 504.48 525.22 510.38 526.5 510.4 526.5 510.51 526.41 510.42 526.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M512.8,507.9h-4.22c-.77,0-1.41.63-1.41,1.41v3.36h7.03v-3.36c0-.77-.63-1.41-1.41-1.41h0ZM510.43,511.96h-1.92v-3.36h1.88v.55h-1.2v.79h1.13v.55h-1.13v.9h1.25v.57ZM511.7,512.02c-.35,0-.62-.08-.8-.23s-.27-.41-.27-.78v-.1h.68v.09c0,.18.03.31.1.4.07.08.18.13.35.13.12,0,.22-.04.29-.11.08-.07.11-.17.11-.31,0-.1-.02-.19-.05-.26-.04-.07-.11-.13-.23-.18-.4-.16-.65-.27-.74-.32-.1-.05-.18-.12-.24-.19s-.12-.16-.16-.27c-.04-.1-.06-.22-.06-.37,0-.32.09-.56.27-.73.18-.17.44-.25.77-.25s.59.08.77.23c.18.15.27.38.27.69v.08h-.65c0-.33-.12-.5-.37-.5s-.39.13-.39.39c0,.12.03.22.08.28.05.06.14.12.27.18l.52.23c.23.09.39.21.49.35.1.14.15.32.15.54,0,.69-.39,1.03-1.17,1.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M710.43,515.48c0-.31-.25-.57-.57-.57-.32,0-.57.25-.58.57,0,.32.25.57.57.57.32,0,.57-.25.58-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M699.48,515.98h12.87v-19.3h-12.87v19.3ZM701.62,511.69h2.14v2.15h-2.14v-2.15ZM710.2,513.84h-4.29v-2.15h4.29v2.15ZM710.2,500.97h-2.15v4.29h2.15v2.15h-2.15v-2.15h-4.29v2.15h2.15v2.14h-4.29v-4.29h2.14v-2.14h2.15v-2.15h-4.29v-2.14h4.29v2.14h2.15v-2.14h2.15v2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M710.3,525.48c.01-2.43-1.95-4.4-4.38-4.42-2.43-.01-4.41,1.95-4.42,4.37-.01,2.43,1.95,4.4,4.38,4.42s4.41-1.95,4.42-4.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M706.49,523.22c0-.32-.26-.58-.57-.58-.32,0-.58.25-.58.57,0,.32.25.58.57.58.32,0,.58-.26.58-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M705.46,527.91s.3-1.62.45-1.61c.14,0,.42,1.62.42,1.62.04.19.12.33.33.33.23,0,.35-.16.33-.33h0s0-.03,0-.03l-.32-1.81-.06-.46c-.01-.08-.05-.29,0-.4.01-.03.04-.07.14-.11l.98-.3h0c.16-.06.33-.15.33-.33,0-.18-.13-.38-.33-.33l-.08.03c-.27.08-1.12.3-1.72.29-.65,0-1.58-.27-1.77-.33h-.03s0-.01,0-.01h0c-.2-.05-.33.14-.33.32,0,.18.16.27.33.33h.02s.91.33.91.33c.12.04.17.09.18.11h0s.05.11,0,.38l-.06.46-.34,1.79v.04c-.03.17.09.33.32.33.2,0,.29-.14.33-.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "712.42 523.52 711.61 523.52 711.61 519.86 708.05 519.86 708.05 519.06 712.42 519.06 712.42 523.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "700.2 523.47 699.39 523.47 699.39 519.1 703.85 519.1 703.85 519.91 700.2 519.91 700.2 523.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "712.42 531.8 707.96 531.8 707.96 531 711.61 531 711.61 527.44 712.42 527.44 712.42 531.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "699.59 527.39 699.59 531.7 703.8 531.7 703.8 531.2 700.09 531.2 700.09 527.39 699.59 527.39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 717.78,
    y: 495.86,
    width: 36.85,
    height: 36.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M726.62,496.66l.47.47-.47.47-.47-.47.47-.47ZM727.56,496.66l.47.47-.47.47-.47-.47.47-.47ZM731.34,496.66l.47.47-.47.47-.47-.47.47-.47ZM733.23,496.66l.47.47-.47.47-.47-.47.47-.47ZM734.17,496.66l.47.47-.47.47-.47-.47.47-.47ZM736.06,496.66l.47.47-.47.47-.47-.47.47-.47ZM737.01,496.66l.47.47-.47.47-.47-.47.47-.47ZM738.9,496.66l.47.47-.47.47-.47-.47.47-.47ZM739.84,496.66l.47.47-.47.47-.47-.47.47-.47ZM740.79,496.66l.47.47-.47.47-.47-.47.47-.47ZM741.73,496.66l.47.47-.47.47-.47-.47.47-.47ZM743.62,496.66l.47.47-.47.47-.47-.47.47-.47ZM744.57,496.66l.47.47-.47.47-.47-.47.47-.47ZM745.51,496.66l.47.47-.47.47-.47-.47.47-.47ZM727.56,497.61l.47.47-.47.47-.47-.47.47-.47ZM729.45,497.61l.47.47-.47.47-.47-.47.47-.47ZM737.01,497.61l.47.47-.47.47-.47-.47.47-.47ZM737.95,497.61l.47.47-.47.47-.47-.47.47-.47ZM741.73,497.61l.47.47-.47.47-.47-.47.47-.47ZM745.51,497.61l.47.47-.47.47-.47-.47.47-.47ZM727.56,498.55l.47.47-.47.47-.47-.47.47-.47ZM729.45,498.55l.47.47-.47.47-.47-.47.47-.47ZM730.4,498.55l.47.47-.47.47-.47-.47.47-.47ZM731.34,498.55l.47.47-.47.47-.47-.47.47-.47ZM732.29,498.55l.47.47-.47.47-.47-.47.47-.47ZM733.23,498.55l.47.47-.47.47-.47-.47.47-.47ZM735.12,498.55l.47.47-.47.47-.47-.47.47-.47ZM737.01,498.55l.47.47-.47.47-.47-.47.47-.47ZM737.95,498.55l.47.47-.47.47-.47-.47.47-.47ZM738.9,498.55l.47.47-.47.47-.47-.47.47-.47ZM740.79,498.55l.47.47-.47.47-.47-.47.47-.47ZM741.73,498.55l.47.47-.47.47-.47-.47.47-.47ZM744.57,498.55l.47.47-.47.47-.47-.47.47-.47ZM726.62,499.5l.47.47-.47.47-.47-.47.47-.47ZM728.51,499.5l.47.47-.47.47-.47-.47.47-.47ZM730.4,499.5l.47.47-.47.47-.47-.47.47-.47ZM731.34,499.5l.47.47-.47.47-.47-.47.47-.47ZM737.01,499.5l.47.47-.47.47-.47-.47.47-.47ZM737.95,499.5l.47.47-.47.47-.47-.47.47-.47ZM739.84,499.5l.47.47-.47.47-.47-.47.47-.47ZM740.79,499.5l.47.47-.47.47-.47-.47.47-.47ZM741.73,499.5l.47.47-.47.47-.47-.47.47-.47ZM742.68,499.5l.47.47-.47.47-.47-.47.47-.47ZM743.62,499.5l.47.47-.47.47-.47-.47.47-.47ZM745.51,499.5l.47.47-.47.47-.47-.47.47-.47ZM726.62,500.44l.47.47-.47.47-.47-.47.47-.47ZM728.51,500.44l.47.47-.47.47-.47-.47.47-.47ZM729.45,500.44l.47.47-.47.47-.47-.47.47-.47ZM731.34,500.44l.47.47-.47.47-.47-.47.47-.47ZM735.12,500.44l.47.47-.47.47-.47-.47.47-.47ZM737.95,500.44l.47.47-.47.47-.47-.47.47-.47ZM739.84,500.44l.47.47-.47.47-.47-.47.47-.47ZM740.79,500.44l.47.47-.47.47-.47-.47.47-.47ZM741.73,500.44l.47.47-.47.47-.47-.47.47-.47ZM743.62,500.44l.47.47-.47.47-.47-.47.47-.47ZM744.57,500.44l.47.47-.47.47-.47-.47.47-.47ZM726.62,501.39l.47.47-.47.47-.47-.47.47-.47ZM728.51,501.39l.47.47-.47.47-.47-.47.47-.47ZM730.4,501.39l.47.47-.47.47-.47-.47.47-.47ZM731.34,501.39l.47.47-.47.47-.47-.47.47-.47ZM733.23,501.39l.47.47-.47.47-.47-.47.47-.47ZM734.17,501.39l.47.47-.47.47-.47-.47.47-.47ZM737.01,501.39l.47.47-.47.47-.47-.47.47-.47ZM737.95,501.39l.47.47-.47.47-.47-.47.47-.47ZM741.73,501.39l.47.47-.47.47-.47-.47.47-.47ZM745.51,501.39l.47.47-.47.47-.47-.47.47-.47ZM726.62,502.33l.47.47-.47.47-.47-.47.47-.47ZM728.51,502.33l.47.47-.47.47-.47-.47.47-.47ZM730.4,502.33l.47.47-.47.47-.47-.47.47-.47ZM732.29,502.33l.47.47-.47.47-.47-.47.47-.47ZM734.17,502.33l.47.47-.47.47-.47-.47.47-.47ZM736.06,502.33l.47.47-.47.47-.47-.47.47-.47ZM737.95,502.33l.47.47-.47.47-.47-.47.47-.47ZM739.84,502.33l.47.47-.47.47-.47-.47.47-.47ZM741.73,502.33l.47.47-.47.47-.47-.47.47-.47ZM743.62,502.33l.47.47-.47.47-.47-.47.47-.47ZM745.51,502.33l.47.47-.47.47-.47-.47.47-.47ZM726.62,503.28l.47.47-.47.47-.47-.47.47-.47ZM727.56,503.28l.47.47-.47.47-.47-.47.47-.47ZM730.4,503.28l.47.47-.47.47-.47-.47.47-.47ZM731.34,503.28l.47.47-.47.47-.47-.47.47-.47ZM732.29,503.28l.47.47-.47.47-.47-.47.47-.47ZM734.17,503.28l.47.47-.47.47-.47-.47.47-.47ZM735.12,503.28l.47.47-.47.47-.47-.47.47-.47ZM736.06,503.28l.47.47-.47.47-.47-.47.47-.47ZM738.9,503.28l.47.47-.47.47-.47-.47.47-.47ZM740.79,503.28l.47.47-.47.47-.47-.47.47-.47ZM744.57,503.28l.47.47-.47.47-.47-.47.47-.47ZM745.51,503.28l.47.47-.47.47-.47-.47.47-.47ZM719.06,504.22l.47.47-.47.47-.47-.47.47-.47ZM722.84,504.22l.47.47-.47.47-.47-.47.47-.47ZM724.73,504.22l.47.47-.47.47-.47-.47.47-.47ZM725.67,504.22l.47.47-.47.47-.47-.47.47-.47ZM726.62,504.22l.47.47-.47.47-.47-.47.47-.47ZM727.56,504.22l.47.47-.47.47-.47-.47.47-.47ZM728.51,504.22l.47.47-.47.47-.47-.47.47-.47ZM729.45,504.22l.47.47-.47.47-.47-.47.47-.47ZM731.34,504.22l.47.47-.47.47-.47-.47.47-.47ZM732.29,504.22l.47.47-.47.47-.47-.47.47-.47ZM736.06,504.22l.47.47-.47.47-.47-.47.47-.47ZM737.01,504.22l.47.47-.47.47-.47-.47.47-.47ZM737.95,504.22l.47.47-.47.47-.47-.47.47-.47ZM738.9,504.22l.47.47-.47.47-.47-.47.47-.47ZM743.62,504.22l.47.47-.47.47-.47-.47.47-.47ZM746.46,504.22l.47.47-.47.47-.47-.47.47-.47ZM747.4,504.22l.47.47-.47.47-.47-.47.47-.47ZM748.35,504.22l.47.47-.47.47-.47-.47.47-.47ZM749.29,504.22l.47.47-.47.47-.47-.47.47-.47ZM750.24,504.22l.47.47-.47.47-.47-.47.47-.47ZM753.07,504.22l.47.47-.47.47-.47-.47.47-.47ZM719.06,505.17l.47.47-.47.47-.47-.47.47-.47ZM720,505.17l.47.47-.47.47-.47-.47.47-.47ZM720.95,505.17l.47.47-.47.47-.47-.47.47-.47ZM721.89,505.17l.47.47-.47.47-.47-.47.47-.47ZM722.84,505.17l.47.47-.47.47-.47-.47.47-.47ZM723.78,505.17l.47.47-.47.47-.47-.47.47-.47ZM725.67,505.17l.47.47-.47.47-.47-.47.47-.47ZM726.62,505.17l.47.47-.47.47-.47-.47.47-.47ZM727.56,505.17l.47.47-.47.47-.47-.47.47-.47ZM730.4,505.17l.47.47-.47.47-.47-.47.47-.47ZM731.34,505.17l.47.47-.47.47-.47-.47.47-.47ZM734.17,505.17l.47.47-.47.47-.47-.47.47-.47ZM736.06,505.17l.47.47-.47.47-.47-.47.47-.47ZM737.01,505.17l.47.47-.47.47-.47-.47.47-.47ZM739.84,505.17l.47.47-.47.47-.47-.47.47-.47ZM740.79,505.17l.47.47-.47.47-.47-.47.47-.47ZM741.73,505.17l.47.47-.47.47-.47-.47.47-.47ZM742.68,505.17l.47.47-.47.47-.47-.47.47-.47ZM744.57,505.17l.47.47-.47.47-.47-.47.47-.47ZM745.51,505.17l.47.47-.47.47-.47-.47.47-.47ZM746.46,505.17l.47.47-.47.47-.47-.47.47-.47ZM748.35,505.17l.47.47-.47.47-.47-.47.47-.47ZM749.29,505.17l.47.47-.47.47-.47-.47.47-.47ZM750.24,505.17l.47.47-.47.47-.47-.47.47-.47ZM752.13,505.17l.47.47-.47.47-.47-.47.47-.47ZM719.06,506.11l.47.47-.47.47-.47-.47.47-.47ZM720,506.11l.47.47-.47.47-.47-.47.47-.47ZM721.89,506.11l.47.47-.47.47-.47-.47.47-.47ZM722.84,506.11l.47.47-.47.47-.47-.47.47-.47ZM724.73,506.11l.47.47-.47.47-.47-.47.47-.47ZM726.62,506.11l.47.47-.47.47-.47-.47.47-.47ZM727.56,506.11l.47.47-.47.47-.47-.47.47-.47ZM730.4,506.11l.47.47-.47.47-.47-.47.47-.47ZM734.17,506.11l.47.47-.47.47-.47-.47.47-.47ZM735.12,506.11l.47.47-.47.47-.47-.47.47-.47ZM738.9,506.11l.47.47-.47.47-.47-.47.47-.47ZM739.84,506.11l.47.47-.47.47-.47-.47.47-.47ZM740.79,506.11l.47.47-.47.47-.47-.47.47-.47ZM741.73,506.11l.47.47-.47.47-.47-.47.47-.47ZM742.68,506.11l.47.47-.47.47-.47-.47.47-.47ZM744.57,506.11l.47.47-.47.47-.47-.47.47-.47ZM750.24,506.11l.47.47-.47.47-.47-.47.47-.47ZM751.18,506.11l.47.47-.47.47-.47-.47.47-.47ZM719.06,507.06l.47.47-.47.47-.47-.47.47-.47ZM721.89,507.06l.47.47-.47.47-.47-.47.47-.47ZM722.84,507.06l.47.47-.47.47-.47-.47.47-.47ZM727.56,507.06l.47.47-.47.47-.47-.47.47-.47ZM729.45,507.06l.47.47-.47.47-.47-.47.47-.47ZM735.12,507.06l.47.47-.47.47-.47-.47.47-.47ZM736.06,507.06l.47.47-.47.47-.47-.47.47-.47ZM737.01,507.06l.47.47-.47.47-.47-.47.47-.47ZM737.95,507.06l.47.47-.47.47-.47-.47.47-.47ZM738.9,507.06l.47.47-.47.47-.47-.47.47-.47ZM743.62,507.06l.47.47-.47.47-.47-.47.47-.47ZM747.4,507.06l.47.47-.47.47-.47-.47.47-.47ZM749.29,507.06l.47.47-.47.47-.47-.47.47-.47ZM750.24,507.06l.47.47-.47.47-.47-.47.47-.47ZM751.18,507.06l.47.47-.47.47-.47-.47.47-.47ZM752.13,507.06l.47.47-.47.47-.47-.47.47-.47ZM720.95,508l.47.47-.47.47-.47-.47.47-.47ZM721.89,508l.47.47-.47.47-.47-.47.47-.47ZM722.84,508l.47.47-.47.47-.47-.47.47-.47ZM724.73,508l.47.47-.47.47-.47-.47.47-.47ZM725.67,508l.47.47-.47.47-.47-.47.47-.47ZM726.62,508l.47.47-.47.47-.47-.47.47-.47ZM728.51,508l.47.47-.47.47-.47-.47.47-.47ZM729.45,508l.47.47-.47.47-.47-.47.47-.47ZM730.4,508l.47.47-.47.47-.47-.47.47-.47ZM731.34,508l.47.47-.47.47-.47-.47.47-.47ZM733.23,508l.47.47-.47.47-.47-.47.47-.47ZM734.17,508l.47.47-.47.47-.47-.47.47-.47ZM735.12,508l.47.47-.47.47-.47-.47.47-.47ZM736.06,508l.47.47-.47.47-.47-.47.47-.47ZM737.01,508l.47.47-.47.47-.47-.47.47-.47ZM738.9,508l.47.47-.47.47-.47-.47.47-.47ZM746.46,508l.47.47-.47.47-.47-.47.47-.47ZM747.4,508l.47.47-.47.47-.47-.47.47-.47ZM750.24,508l.47.47-.47.47-.47-.47.47-.47ZM751.18,508l.47.47-.47.47-.47-.47.47-.47ZM752.13,508l.47.47-.47.47-.47-.47.47-.47ZM753.07,508l.47.47-.47.47-.47-.47.47-.47ZM720,508.95l.47.47-.47.47-.47-.47.47-.47ZM721.89,508.95l.47.47-.47.47-.47-.47.47-.47ZM722.84,508.95l.47.47-.47.47-.47-.47.47-.47ZM725.67,508.95l.47.47-.47.47-.47-.47.47-.47ZM727.56,508.95l.47.47-.47.47-.47-.47.47-.47ZM728.51,508.95l.47.47-.47.47-.47-.47.47-.47ZM729.45,508.95l.47.47-.47.47-.47-.47.47-.47ZM730.4,508.95l.47.47-.47.47-.47-.47.47-.47ZM732.29,508.95l.47.47-.47.47-.47-.47.47-.47ZM733.23,508.95l.47.47-.47.47-.47-.47.47-.47ZM735.12,508.95l.47.47-.47.47-.47-.47.47-.47ZM737.95,508.95l.47.47-.47.47-.47-.47.47-.47ZM739.84,508.95l.47.47-.47.47-.47-.47.47-.47ZM740.79,508.95l.47.47-.47.47-.47-.47.47-.47ZM741.73,508.95l.47.47-.47.47-.47-.47.47-.47ZM743.62,508.95l.47.47-.47.47-.47-.47.47-.47ZM744.57,508.95l.47.47-.47.47-.47-.47.47-.47ZM745.51,508.95l.47.47-.47.47-.47-.47.47-.47ZM746.46,508.95l.47.47-.47.47-.47-.47.47-.47ZM749.29,508.95l.47.47-.47.47-.47-.47.47-.47ZM750.24,508.95l.47.47-.47.47-.47-.47.47-.47ZM752.13,508.95l.47.47-.47.47-.47-.47.47-.47ZM719.06,509.89l.47.47-.47.47-.47-.47.47-.47ZM720,509.89l.47.47-.47.47-.47-.47.47-.47ZM723.78,509.89l.47.47-.47.47-.47-.47.47-.47ZM724.73,509.89l.47.47-.47.47-.47-.47.47-.47ZM730.4,509.89l.47.47-.47.47-.47-.47.47-.47ZM733.23,509.89l.47.47-.47.47-.47-.47.47-.47ZM734.17,509.89l.47.47-.47.47-.47-.47.47-.47ZM736.06,509.89l.47.47-.47.47-.47-.47.47-.47ZM737.95,509.89l.47.47-.47.47-.47-.47.47-.47ZM738.9,509.89l.47.47-.47.47-.47-.47.47-.47ZM739.84,509.89l.47.47-.47.47-.47-.47.47-.47ZM740.79,509.89l.47.47-.47.47-.47-.47.47-.47ZM741.73,509.89l.47.47-.47.47-.47-.47.47-.47ZM743.62,509.89l.47.47-.47.47-.47-.47.47-.47ZM744.57,509.89l.47.47-.47.47-.47-.47.47-.47ZM745.51,509.89l.47.47-.47.47-.47-.47.47-.47ZM746.46,509.89l.47.47-.47.47-.47-.47.47-.47ZM748.35,509.89l.47.47-.47.47-.47-.47.47-.47ZM749.29,509.89l.47.47-.47.47-.47-.47.47-.47ZM750.24,509.89l.47.47-.47.47-.47-.47.47-.47ZM751.18,509.89l.47.47-.47.47-.47-.47.47-.47ZM752.13,509.89l.47.47-.47.47-.47-.47.47-.47ZM719.06,510.84l.47.47-.47.47-.47-.47.47-.47ZM720.95,510.84l.47.47-.47.47-.47-.47.47-.47ZM721.89,510.84l.47.47-.47.47-.47-.47.47-.47ZM723.78,510.84l.47.47-.47.47-.47-.47.47-.47ZM725.67,510.84l.47.47-.47.47-.47-.47.47-.47ZM727.56,510.84l.47.47-.47.47-.47-.47.47-.47ZM728.51,510.84l.47.47-.47.47-.47-.47.47-.47ZM730.4,510.84l.47.47-.47.47-.47-.47.47-.47ZM732.29,510.84l.47.47-.47.47-.47-.47.47-.47ZM738.9,510.84l.47.47-.47.47-.47-.47.47-.47ZM741.73,510.84l.47.47-.47.47-.47-.47.47-.47ZM743.62,510.84l.47.47-.47.47-.47-.47.47-.47ZM745.51,510.84l.47.47-.47.47-.47-.47.47-.47ZM746.46,510.84l.47.47-.47.47-.47-.47.47-.47ZM748.35,510.84l.47.47-.47.47-.47-.47.47-.47ZM751.18,510.84l.47.47-.47.47-.47-.47.47-.47ZM752.13,510.84l.47.47-.47.47-.47-.47.47-.47ZM720,511.78l.47.47-.47.47-.47-.47.47-.47ZM722.84,511.78l.47.47-.47.47-.47-.47.47-.47ZM724.73,511.78l.47.47-.47.47-.47-.47.47-.47ZM725.67,511.78l.47.47-.47.47-.47-.47.47-.47ZM728.51,511.78l.47.47-.47.47-.47-.47.47-.47ZM729.45,511.78l.47.47-.47.47-.47-.47.47-.47ZM730.4,511.78l.47.47-.47.47-.47-.47.47-.47ZM732.29,511.78l.47.47-.47.47-.47-.47.47-.47ZM733.23,511.78l.47.47-.47.47-.47-.47.47-.47ZM734.17,511.78l.47.47-.47.47-.47-.47.47-.47ZM737.01,511.78l.47.47-.47.47-.47-.47.47-.47ZM737.95,511.78l.47.47-.47.47-.47-.47.47-.47ZM738.9,511.78l.47.47-.47.47-.47-.47.47-.47ZM740.79,511.78l.47.47-.47.47-.47-.47.47-.47ZM743.62,511.78l.47.47-.47.47-.47-.47.47-.47ZM747.4,511.78l.47.47-.47.47-.47-.47.47-.47ZM750.24,511.78l.47.47-.47.47-.47-.47.47-.47ZM751.18,511.78l.47.47-.47.47-.47-.47.47-.47ZM752.13,511.78l.47.47-.47.47-.47-.47.47-.47ZM753.07,511.78l.47.47-.47.47-.47-.47.47-.47ZM720,512.73l.47.47-.47.47-.47-.47.47-.47ZM721.89,512.73l.47.47-.47.47-.47-.47.47-.47ZM723.78,512.73l.47.47-.47.47-.47-.47.47-.47ZM725.67,512.73l.47.47-.47.47-.47-.47.47-.47ZM727.56,512.73l.47.47-.47.47-.47-.47.47-.47ZM728.51,512.73l.47.47-.47.47-.47-.47.47-.47ZM729.45,512.73l.47.47-.47.47-.47-.47.47-.47ZM732.29,512.73l.47.47-.47.47-.47-.47.47-.47ZM736.06,512.73l.47.47-.47.47-.47-.47.47-.47ZM737.01,512.73l.47.47-.47.47-.47-.47.47-.47ZM740.79,512.73l.47.47-.47.47-.47-.47.47-.47ZM741.73,512.73l.47.47-.47.47-.47-.47.47-.47ZM744.57,512.73l.47.47-.47.47-.47-.47.47-.47ZM745.51,512.73l.47.47-.47.47-.47-.47.47-.47ZM746.46,512.73l.47.47-.47.47-.47-.47.47-.47ZM748.35,512.73l.47.47-.47.47-.47-.47.47-.47ZM749.29,512.73l.47.47-.47.47-.47-.47.47-.47ZM750.24,512.73l.47.47-.47.47-.47-.47.47-.47ZM752.13,512.73l.47.47-.47.47-.47-.47.47-.47ZM719.06,513.67l.47.47-.47.47-.47-.47.47-.47ZM720,513.67l.47.47-.47.47-.47-.47.47-.47ZM720.95,513.67l.47.47-.47.47-.47-.47.47-.47ZM722.84,513.67l.47.47-.47.47-.47-.47.47-.47ZM723.78,513.67l.47.47-.47.47-.47-.47.47-.47ZM724.73,513.67l.47.47-.47.47-.47-.47.47-.47ZM728.51,513.67l.47.47-.47.47-.47-.47.47-.47ZM730.4,513.67l.47.47-.47.47-.47-.47.47-.47ZM731.34,513.67l.47.47-.47.47-.47-.47.47-.47ZM732.29,513.67l.47.47-.47.47-.47-.47.47-.47ZM733.23,513.67l.47.47-.47.47-.47-.47.47-.47ZM738.9,513.67l.47.47-.47.47-.47-.47.47-.47ZM740.79,513.67l.47.47-.47.47-.47-.47.47-.47ZM742.68,513.67l.47.47-.47.47-.47-.47.47-.47ZM743.62,513.67l.47.47-.47.47-.47-.47.47-.47ZM744.57,513.67l.47.47-.47.47-.47-.47.47-.47ZM745.51,513.67l.47.47-.47.47-.47-.47.47-.47ZM719.06,514.62l.47.47-.47.47-.47-.47.47-.47ZM720,514.62l.47.47-.47.47-.47-.47.47-.47ZM720.95,514.62l.47.47-.47.47-.47-.47.47-.47ZM721.89,514.62l.47.47-.47.47-.47-.47.47-.47ZM723.78,514.62l.47.47-.47.47-.47-.47.47-.47ZM726.62,514.62l.47.47-.47.47-.47-.47.47-.47ZM730.4,514.62l.47.47-.47.47-.47-.47.47-.47ZM732.29,514.62l.47.47-.47.47-.47-.47.47-.47ZM733.23,514.62l.47.47-.47.47-.47-.47.47-.47ZM734.17,514.62l.47.47-.47.47-.47-.47.47-.47ZM735.12,514.62l.47.47-.47.47-.47-.47.47-.47ZM737.01,514.62l.47.47-.47.47-.47-.47.47-.47ZM738.9,514.62l.47.47-.47.47-.47-.47.47-.47ZM739.84,514.62l.47.47-.47.47-.47-.47.47-.47ZM743.62,514.62l.47.47-.47.47-.47-.47.47-.47ZM747.4,514.62l.47.47-.47.47-.47-.47.47-.47ZM750.24,514.62l.47.47-.47.47-.47-.47.47-.47ZM751.18,514.62l.47.47-.47.47-.47-.47.47-.47ZM752.13,514.62l.47.47-.47.47-.47-.47.47-.47ZM719.06,515.56l.47.47-.47.47-.47-.47.47-.47ZM721.89,515.56l.47.47-.47.47-.47-.47.47-.47ZM722.84,515.56l.47.47-.47.47-.47-.47.47-.47ZM723.78,515.56l.47.47-.47.47-.47-.47.47-.47ZM724.73,515.56l.47.47-.47.47-.47-.47.47-.47ZM725.67,515.56l.47.47-.47.47-.47-.47.47-.47ZM726.62,515.56l.47.47-.47.47-.47-.47.47-.47ZM728.51,515.56l.47.47-.47.47-.47-.47.47-.47ZM730.4,515.56l.47.47-.47.47-.47-.47.47-.47ZM731.34,515.56l.47.47-.47.47-.47-.47.47-.47ZM735.12,515.56l.47.47-.47.47-.47-.47.47-.47ZM736.06,515.56l.47.47-.47.47-.47-.47.47-.47ZM738.9,515.56l.47.47-.47.47-.47-.47.47-.47ZM741.73,515.56l.47.47-.47.47-.47-.47.47-.47ZM745.51,515.56l.47.47-.47.47-.47-.47.47-.47ZM747.4,515.56l.47.47-.47.47-.47-.47.47-.47ZM750.24,515.56l.47.47-.47.47-.47-.47.47-.47ZM751.18,515.56l.47.47-.47.47-.47-.47.47-.47ZM719.06,516.51l.47.47-.47.47-.47-.47.47-.47ZM720.95,516.51l.47.47-.47.47-.47-.47.47-.47ZM726.62,516.51l.47.47-.47.47-.47-.47.47-.47ZM727.56,516.51l.47.47-.47.47-.47-.47.47-.47ZM729.45,516.51l.47.47-.47.47-.47-.47.47-.47ZM730.4,516.51l.47.47-.47.47-.47-.47.47-.47ZM733.23,516.51l.47.47-.47.47-.47-.47.47-.47ZM734.17,516.51l.47.47-.47.47-.47-.47.47-.47ZM737.95,516.51l.47.47-.47.47-.47-.47.47-.47ZM738.9,516.51l.47.47-.47.47-.47-.47.47-.47ZM739.84,516.51l.47.47-.47.47-.47-.47.47-.47ZM740.79,516.51l.47.47-.47.47-.47-.47.47-.47ZM741.73,516.51l.47.47-.47.47-.47-.47.47-.47ZM743.62,516.51l.47.47-.47.47-.47-.47.47-.47ZM744.57,516.51l.47.47-.47.47-.47-.47.47-.47ZM745.51,516.51l.47.47-.47.47-.47-.47.47-.47ZM749.29,516.51l.47.47-.47.47-.47-.47.47-.47ZM752.13,516.51l.47.47-.47.47-.47-.47.47-.47ZM722.84,517.45l.47.47-.47.47-.47-.47.47-.47ZM724.73,517.45l.47.47-.47.47-.47-.47.47-.47ZM726.62,517.45l.47.47-.47.47-.47-.47.47-.47ZM727.56,517.45l.47.47-.47.47-.47-.47.47-.47ZM729.45,517.45l.47.47-.47.47-.47-.47.47-.47ZM732.29,517.45l.47.47-.47.47-.47-.47.47-.47ZM733.23,517.45l.47.47-.47.47-.47-.47.47-.47ZM735.12,517.45l.47.47-.47.47-.47-.47.47-.47ZM738.9,517.45l.47.47-.47.47-.47-.47.47-.47ZM740.79,517.45l.47.47-.47.47-.47-.47.47-.47ZM744.57,517.45l.47.47-.47.47-.47-.47.47-.47ZM746.46,517.45l.47.47-.47.47-.47-.47.47-.47ZM748.35,517.45l.47.47-.47.47-.47-.47.47-.47ZM749.29,517.45l.47.47-.47.47-.47-.47.47-.47ZM750.24,517.45l.47.47-.47.47-.47-.47.47-.47ZM751.18,517.45l.47.47-.47.47-.47-.47.47-.47ZM752.13,517.45l.47.47-.47.47-.47-.47.47-.47ZM719.06,518.4l.47.47-.47.47-.47-.47.47-.47ZM720.95,518.4l.47.47-.47.47-.47-.47.47-.47ZM721.89,518.4l.47.47-.47.47-.47-.47.47-.47ZM722.84,518.4l.47.47-.47.47-.47-.47.47-.47ZM723.78,518.4l.47.47-.47.47-.47-.47.47-.47ZM726.62,518.4l.47.47-.47.47-.47-.47.47-.47ZM727.56,518.4l.47.47-.47.47-.47-.47.47-.47ZM731.34,518.4l.47.47-.47.47-.47-.47.47-.47ZM733.23,518.4l.47.47-.47.47-.47-.47.47-.47ZM734.17,518.4l.47.47-.47.47-.47-.47.47-.47ZM735.12,518.4l.47.47-.47.47-.47-.47.47-.47ZM736.06,518.4l.47.47-.47.47-.47-.47.47-.47ZM738.9,518.4l.47.47-.47.47-.47-.47.47-.47ZM744.57,518.4l.47.47-.47.47-.47-.47.47-.47ZM745.51,518.4l.47.47-.47.47-.47-.47.47-.47ZM746.46,518.4l.47.47-.47.47-.47-.47.47-.47ZM747.4,518.4l.47.47-.47.47-.47-.47.47-.47ZM748.35,518.4l.47.47-.47.47-.47-.47.47-.47ZM749.29,518.4l.47.47-.47.47-.47-.47.47-.47ZM750.24,518.4l.47.47-.47.47-.47-.47.47-.47ZM751.18,518.4l.47.47-.47.47-.47-.47.47-.47ZM752.13,518.4l.47.47-.47.47-.47-.47.47-.47ZM724.73,519.34l.47.47-.47.47-.47-.47.47-.47ZM727.56,519.34l.47.47-.47.47-.47-.47.47-.47ZM728.51,519.34l.47.47-.47.47-.47-.47.47-.47ZM729.45,519.34l.47.47-.47.47-.47-.47.47-.47ZM730.4,519.34l.47.47-.47.47-.47-.47.47-.47ZM731.34,519.34l.47.47-.47.47-.47-.47.47-.47ZM733.23,519.34l.47.47-.47.47-.47-.47.47-.47ZM736.06,519.34l.47.47-.47.47-.47-.47.47-.47ZM737.01,519.34l.47.47-.47.47-.47-.47.47-.47ZM738.9,519.34l.47.47-.47.47-.47-.47.47-.47ZM743.62,519.34l.47.47-.47.47-.47-.47.47-.47ZM747.4,519.34l.47.47-.47.47-.47-.47.47-.47ZM750.24,519.34l.47.47-.47.47-.47-.47.47-.47ZM751.18,519.34l.47.47-.47.47-.47-.47.47-.47ZM719.06,520.28l.47.47-.47.47-.47-.47.47-.47ZM720,520.28l.47.47-.47.47-.47-.47.47-.47ZM720.95,520.28l.47.47-.47.47-.47-.47.47-.47ZM721.89,520.28l.47.47-.47.47-.47-.47.47-.47ZM722.84,520.28l.47.47-.47.47-.47-.47.47-.47ZM723.78,520.28l.47.47-.47.47-.47-.47.47-.47ZM728.51,520.28l.47.47-.47.47-.47-.47.47-.47ZM729.45,520.28l.47.47-.47.47-.47-.47.47-.47ZM730.4,520.28l.47.47-.47.47-.47-.47.47-.47ZM734.17,520.28l.47.47-.47.47-.47-.47.47-.47ZM735.12,520.28l.47.47-.47.47-.47-.47.47-.47ZM737.01,520.28l.47.47-.47.47-.47-.47.47-.47ZM739.84,520.28l.47.47-.47.47-.47-.47.47-.47ZM740.79,520.28l.47.47-.47.47-.47-.47.47-.47ZM741.73,520.28l.47.47-.47.47-.47-.47.47-.47ZM744.57,520.28l.47.47-.47.47-.47-.47.47-.47ZM746.46,520.28l.47.47-.47.47-.47-.47.47-.47ZM748.35,520.28l.47.47-.47.47-.47-.47.47-.47ZM749.29,520.28l.47.47-.47.47-.47-.47.47-.47ZM750.24,520.28l.47.47-.47.47-.47-.47.47-.47ZM720.95,521.23l.47.47-.47.47-.47-.47.47-.47ZM724.73,521.23l.47.47-.47.47-.47-.47.47-.47ZM725.67,521.23l.47.47-.47.47-.47-.47.47-.47ZM727.56,521.23l.47.47-.47.47-.47-.47.47-.47ZM728.51,521.23l.47.47-.47.47-.47-.47.47-.47ZM729.45,521.23l.47.47-.47.47-.47-.47.47-.47ZM730.4,521.23l.47.47-.47.47-.47-.47.47-.47ZM731.34,521.23l.47.47-.47.47-.47-.47.47-.47ZM732.29,521.23l.47.47-.47.47-.47-.47.47-.47ZM734.17,521.23l.47.47-.47.47-.47-.47.47-.47ZM736.06,521.23l.47.47-.47.47-.47-.47.47-.47ZM738.9,521.23l.47.47-.47.47-.47-.47.47-.47ZM740.79,521.23l.47.47-.47.47-.47-.47.47-.47ZM741.73,521.23l.47.47-.47.47-.47-.47.47-.47ZM743.62,521.23l.47.47-.47.47-.47-.47.47-.47ZM744.57,521.23l.47.47-.47.47-.47-.47.47-.47ZM745.51,521.23l.47.47-.47.47-.47-.47.47-.47ZM747.4,521.23l.47.47-.47.47-.47-.47.47-.47ZM748.35,521.23l.47.47-.47.47-.47-.47.47-.47ZM720.95,522.17l.47.47-.47.47-.47-.47.47-.47ZM725.67,522.17l.47.47-.47.47-.47-.47.47-.47ZM727.56,522.17l.47.47-.47.47-.47-.47.47-.47ZM735.12,522.17l.47.47-.47.47-.47-.47.47-.47ZM736.06,522.17l.47.47-.47.47-.47-.47.47-.47ZM737.01,522.17l.47.47-.47.47-.47-.47.47-.47ZM737.95,522.17l.47.47-.47.47-.47-.47.47-.47ZM738.9,522.17l.47.47-.47.47-.47-.47.47-.47ZM739.84,522.17l.47.47-.47.47-.47-.47.47-.47ZM740.79,522.17l.47.47-.47.47-.47-.47.47-.47ZM741.73,522.17l.47.47-.47.47-.47-.47.47-.47ZM743.62,522.17l.47.47-.47.47-.47-.47.47-.47ZM744.57,522.17l.47.47-.47.47-.47-.47.47-.47ZM746.46,522.17l.47.47-.47.47-.47-.47.47-.47ZM747.4,522.17l.47.47-.47.47-.47-.47.47-.47ZM749.29,522.17l.47.47-.47.47-.47-.47.47-.47ZM750.24,522.17l.47.47-.47.47-.47-.47.47-.47ZM751.18,522.17l.47.47-.47.47-.47-.47.47-.47ZM719.06,523.12l.47.47-.47.47-.47-.47.47-.47ZM720,523.12l.47.47-.47.47-.47-.47.47-.47ZM721.89,523.12l.47.47-.47.47-.47-.47.47-.47ZM722.84,523.12l.47.47-.47.47-.47-.47.47-.47ZM723.78,523.12l.47.47-.47.47-.47-.47.47-.47ZM724.73,523.12l.47.47-.47.47-.47-.47.47-.47ZM726.62,523.12l.47.47-.47.47-.47-.47.47-.47ZM728.51,523.12l.47.47-.47.47-.47-.47.47-.47ZM729.45,523.12l.47.47-.47.47-.47-.47.47-.47ZM732.29,523.12l.47.47-.47.47-.47-.47.47-.47ZM733.23,523.12l.47.47-.47.47-.47-.47.47-.47ZM735.12,523.12l.47.47-.47.47-.47-.47.47-.47ZM738.9,523.12l.47.47-.47.47-.47-.47.47-.47ZM743.62,523.12l.47.47-.47.47-.47-.47.47-.47ZM745.51,523.12l.47.47-.47.47-.47-.47.47-.47ZM746.46,523.12l.47.47-.47.47-.47-.47.47-.47ZM747.4,523.12l.47.47-.47.47-.47-.47.47-.47ZM748.35,523.12l.47.47-.47.47-.47-.47.47-.47ZM749.29,523.12l.47.47-.47.47-.47-.47.47-.47ZM750.24,523.12l.47.47-.47.47-.47-.47.47-.47ZM751.18,523.12l.47.47-.47.47-.47-.47.47-.47ZM752.13,523.12l.47.47-.47.47-.47-.47.47-.47ZM726.62,524.06l.47.47-.47.47-.47-.47.47-.47ZM729.45,524.06l.47.47-.47.47-.47-.47.47-.47ZM730.4,524.06l.47.47-.47.47-.47-.47.47-.47ZM732.29,524.06l.47.47-.47.47-.47-.47.47-.47ZM733.23,524.06l.47.47-.47.47-.47-.47.47-.47ZM734.17,524.06l.47.47-.47.47-.47-.47.47-.47ZM735.12,524.06l.47.47-.47.47-.47-.47.47-.47ZM736.06,524.06l.47.47-.47.47-.47-.47.47-.47ZM737.95,524.06l.47.47-.47.47-.47-.47.47-.47ZM739.84,524.06l.47.47-.47.47-.47-.47.47-.47ZM740.79,524.06l.47.47-.47.47-.47-.47.47-.47ZM742.68,524.06l.47.47-.47.47-.47-.47.47-.47ZM743.62,524.06l.47.47-.47.47-.47-.47.47-.47ZM745.51,524.06l.47.47-.47.47-.47-.47.47-.47ZM749.29,524.06l.47.47-.47.47-.47-.47.47-.47ZM751.18,524.06l.47.47-.47.47-.47-.47.47-.47ZM752.13,524.06l.47.47-.47.47-.47-.47.47-.47ZM726.62,525.01l.47.47-.47.47-.47-.47.47-.47ZM727.56,525.01l.47.47-.47.47-.47-.47.47-.47ZM728.51,525.01l.47.47-.47.47-.47-.47.47-.47ZM729.45,525.01l.47.47-.47.47-.47-.47.47-.47ZM730.4,525.01l.47.47-.47.47-.47-.47.47-.47ZM731.34,525.01l.47.47-.47.47-.47-.47.47-.47ZM732.29,525.01l.47.47-.47.47-.47-.47.47-.47ZM733.23,525.01l.47.47-.47.47-.47-.47.47-.47ZM734.17,525.01l.47.47-.47.47-.47-.47.47-.47ZM736.06,525.01l.47.47-.47.47-.47-.47.47-.47ZM738.9,525.01l.47.47-.47.47-.47-.47.47-.47ZM740.79,525.01l.47.47-.47.47-.47-.47.47-.47ZM741.73,525.01l.47.47-.47.47-.47-.47.47-.47ZM743.62,525.01l.47.47-.47.47-.47-.47.47-.47ZM745.51,525.01l.47.47-.47.47-.47-.47.47-.47ZM747.4,525.01l.47.47-.47.47-.47-.47.47-.47ZM749.29,525.01l.47.47-.47.47-.47-.47.47-.47ZM750.24,525.01l.47.47-.47.47-.47-.47.47-.47ZM752.13,525.01l.47.47-.47.47-.47-.47.47-.47ZM729.45,525.95l.47.47-.47.47-.47-.47.47-.47ZM730.4,525.95l.47.47-.47.47-.47-.47.47-.47ZM733.23,525.95l.47.47-.47.47-.47-.47.47-.47ZM737.01,525.95l.47.47-.47.47-.47-.47.47-.47ZM737.95,525.95l.47.47-.47.47-.47-.47.47-.47ZM738.9,525.95l.47.47-.47.47-.47-.47.47-.47ZM740.79,525.95l.47.47-.47.47-.47-.47.47-.47ZM745.51,525.95l.47.47-.47.47-.47-.47.47-.47ZM749.29,525.95l.47.47-.47.47-.47-.47.47-.47ZM750.24,525.95l.47.47-.47.47-.47-.47.47-.47ZM751.18,525.95l.47.47-.47.47-.47-.47.47-.47ZM726.62,526.9l.47.47-.47.47-.47-.47.47-.47ZM727.56,526.9l.47.47-.47.47-.47-.47.47-.47ZM728.51,526.9l.47.47-.47.47-.47-.47.47-.47ZM729.45,526.9l.47.47-.47.47-.47-.47.47-.47ZM730.4,526.9l.47.47-.47.47-.47-.47.47-.47ZM731.34,526.9l.47.47-.47.47-.47-.47.47-.47ZM732.29,526.9l.47.47-.47.47-.47-.47.47-.47ZM734.17,526.9l.47.47-.47.47-.47-.47.47-.47ZM737.01,526.9l.47.47-.47.47-.47-.47.47-.47ZM737.95,526.9l.47.47-.47.47-.47-.47.47-.47ZM738.9,526.9l.47.47-.47.47-.47-.47.47-.47ZM743.62,526.9l.47.47-.47.47-.47-.47.47-.47ZM745.51,526.9l.47.47-.47.47-.47-.47.47-.47ZM746.46,526.9l.47.47-.47.47-.47-.47.47-.47ZM747.4,526.9l.47.47-.47.47-.47-.47.47-.47ZM748.35,526.9l.47.47-.47.47-.47-.47.47-.47ZM749.29,526.9l.47.47-.47.47-.47-.47.47-.47ZM751.18,526.9l.47.47-.47.47-.47-.47.47-.47ZM752.13,526.9l.47.47-.47.47-.47-.47.47-.47ZM728.51,527.84l.47.47-.47.47-.47-.47.47-.47ZM730.4,527.84l.47.47-.47.47-.47-.47.47-.47ZM736.06,527.84l.47.47-.47.47-.47-.47.47-.47ZM737.01,527.84l.47.47-.47.47-.47-.47.47-.47ZM739.84,527.84l.47.47-.47.47-.47-.47.47-.47ZM740.79,527.84l.47.47-.47.47-.47-.47.47-.47ZM741.73,527.84l.47.47-.47.47-.47-.47.47-.47ZM745.51,527.84l.47.47-.47.47-.47-.47.47-.47ZM746.46,527.84l.47.47-.47.47-.47-.47.47-.47ZM747.4,527.84l.47.47-.47.47-.47-.47.47-.47ZM748.35,527.84l.47.47-.47.47-.47-.47.47-.47ZM753.07,527.84l.47.47-.47.47-.47-.47.47-.47ZM728.51,528.79l.47.47-.47.47-.47-.47.47-.47ZM729.45,528.79l.47.47-.47.47-.47-.47.47-.47ZM731.34,528.79l.47.47-.47.47-.47-.47.47-.47ZM733.23,528.79l.47.47-.47.47-.47-.47.47-.47ZM736.06,528.79l.47.47-.47.47-.47-.47.47-.47ZM740.79,528.79l.47.47-.47.47-.47-.47.47-.47ZM742.68,528.79l.47.47-.47.47-.47-.47.47-.47ZM743.62,528.79l.47.47-.47.47-.47-.47.47-.47ZM744.57,528.79l.47.47-.47.47-.47-.47.47-.47ZM747.4,528.79l.47.47-.47.47-.47-.47.47-.47ZM727.56,529.73l.47.47-.47.47-.47-.47.47-.47ZM733.23,529.73l.47.47-.47.47-.47-.47.47-.47ZM734.17,529.73l.47.47-.47.47-.47-.47.47-.47ZM735.12,529.73l.47.47-.47.47-.47-.47.47-.47ZM736.06,529.73l.47.47-.47.47-.47-.47.47-.47ZM738.9,529.73l.47.47-.47.47-.47-.47.47-.47ZM740.79,529.73l.47.47-.47.47-.47-.47.47-.47ZM741.73,529.73l.47.47-.47.47-.47-.47.47-.47ZM743.62,529.73l.47.47-.47.47-.47-.47.47-.47ZM746.46,529.73l.47.47-.47.47-.47-.47.47-.47ZM748.35,529.73l.47.47-.47.47-.47-.47.47-.47ZM749.29,529.73l.47.47-.47.47-.47-.47.47-.47ZM750.24,529.73l.47.47-.47.47-.47-.47.47-.47ZM751.18,529.73l.47.47-.47.47-.47-.47.47-.47ZM752.13,529.73l.47.47-.47.47-.47-.47.47-.47ZM726.62,530.68l.47.47-.47.47-.47-.47.47-.47ZM727.56,530.68l.47.47-.47.47-.47-.47.47-.47ZM729.45,530.68l.47.47-.47.47-.47-.47.47-.47ZM730.4,530.68l.47.47-.47.47-.47-.47.47-.47ZM731.34,530.68l.47.47-.47.47-.47-.47.47-.47ZM734.17,530.68l.47.47-.47.47-.47-.47.47-.47ZM735.12,530.68l.47.47-.47.47-.47-.47.47-.47ZM737.01,530.68l.47.47-.47.47-.47-.47.47-.47ZM738.9,530.68l.47.47-.47.47-.47-.47.47-.47ZM750.24,530.68l.47.47-.47.47-.47-.47.47-.47ZM751.18,530.68l.47.47-.47.47-.47-.47.47-.47ZM752.13,530.68l.47.47-.47.47-.47-.47.47-.47ZM753.07,530.68l.47.47-.47.47-.47-.47.47-.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 718.73,
    y: 496.8,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 719.67,
    y: 497.75,
    width: 4.72,
    height: 4.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M720.62,498.69c.94.19,1.89.19,2.83,0-.19.95-.19,1.89,0,2.84-.95-.19-1.89-.19-2.83,0,.19-.95.19-1.89,0-2.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 747.07,
    y: 496.8,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 748.02,
    y: 497.75,
    width: 4.72,
    height: 4.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M748.96,498.69c.94.19,1.89.19,2.83,0-.19.95-.19,1.89,0,2.84-.95-.19-1.89-.19-2.83,0,.19-.95.19-1.89,0-2.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 718.73,
    y: 525.15,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 719.67,
    y: 526.09,
    width: 4.72,
    height: 4.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M720.62,527.04c.94.19,1.89.19,2.83,0-.19.95-.19,1.89,0,2.84-.95-.19-1.89-.19-2.83,0,.19-.95.19-1.89,0-2.84"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarlk3New);
export default __webpack_public_path__ + "static/media/Varlık3new.2a0bc706d9ed9816a0325960b6041cb7.svg";
export { ForwardRef as ReactComponent };